<!--教研驾驶舱 · 区域教科研数据中枢（区域综合数据看板）  -->
<template>
    <div class="stat-container cockpit-root" :class="{ 'side-collapsed': sideCollapsed }" :style="fitStyle">
        <!-- ============ 左侧导航 ============ -->
        <div class="l-stat-container">
            <div class="org-container">
                <div class="org-logo">{{ sideCollapsed ? '教' : '教研驾驶舱' }}</div>
                <div class="school-name">{{ meta.orgName }}</div>
                <div class="org-name">{{ meta.base }}</div>
            </div>
            <div class="menu-container">
                <div v-for="p in PANELS" :key="p.key"
                     class="menu-item"
                     :class="{ 'menu-active': activePanel === p.key }"
                     :data-label="p.name"
                     @click="switchPanel(p.key)">
                    <span class="mi-ico" v-html="MENU_ICONS[p.key]"></span>
                    <span class="mi-label">{{ p.name }}</span>
                </div>
            </div>
        </div>

        <!-- ============ 右侧主区 ============ -->
        <div class="r-stat-container">
            <div class="topbar">
                <button class="side-toggle" type="button" title="收起 / 展开左侧导航" @click="toggleSide">
                    <svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor"
                         stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M15 5.5L9 12l6 6.5"/>
                    </svg>
                </button>
                <template v-if="activePanel === 'studio-mst'">
                    <button class="mst-tab" :class="{ on: mstTab === 't1' }" @click="switchTab('studio-mst', 't1')">成员与结构</button>
                    <button class="mst-tab" :class="{ on: mstTab === 't2' }" @click="switchTab('studio-mst', 't2')">成果与产出</button>
                </template>
                <template v-if="activePanel === 'studio-pr'">
                    <button class="mst-tab" :class="{ on: prTab === 't1' }" @click="switchTab('studio-pr', 't1')">成员与结构</button>
                    <button class="mst-tab" :class="{ on: prTab === 't2' }" @click="switchTab('studio-pr', 't2')">成果与产出</button>
                </template>
                <template v-if="activePanel === 'research'">
                    <button class="mst-tab" :class="{ on: rsTab === 't1' }" @click="switchTab('research', 't1')">课题引领</button>
                    <button class="mst-tab" :class="{ on: rsTab === 't2' }" @click="switchTab('research', 't2')">教研赛事</button>
                    <button class="mst-tab" :class="{ on: rsTab === 't3' }" @click="switchTab('research', 't3')">专题活动</button>
                </template>
                <div class="top-title">{{ panelName }}</div>
                <div class="top-spacer"></div>
                <div class="top-ctl">统计组织
                    <el-select v-model="orgId" filterable size="small" style="width: 220px" placeholder="请选择"
                               @change="onOrgChange">
                        <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName" :value="item.orgId"/>
                    </el-select>
                </div>
            </div>

            <div class="viewport">
                <!-- ==================== 面板1：区域教研总览 ==================== -->
                <div class="panel ov-dark" id="panel-overview" v-show="activePanel === 'overview'" v-loading="loading.overview">
                    <div class="ov-wrap">
                        <!-- 核心指标横条：原地图卡片下方的统计数据挪至面板顶部，一横条展示；高度不足时可滑动 -->
                        <div class="kpi-row ov-kpi-strip" v-if="ovKpiStrip.length">
                            <div v-for="(k, i) in ovKpiStrip" :key="'ks' + i" class="kpi-item" :class="k.a">
                                <div class="kpi-val">{{ k.v }}<span v-if="k.u" class="u">{{ k.u }}</span></div>
                                <div class="kpi-lab">{{ k.l }}</div>
                                <div v-if="k.sub" class="kpi-sub">{{ k.sub }}</div>
                            </div>
                        </div>
                        <div class="ov-main">
                            <div class="ov-col">
                                <div class="card">
                                    <div class="card-hd"><i></i><span>各学科教师分布</span><em class="src real">接口数据</em>
                                        <div class="hd-seg"><div class="ss-seg" id="o1seg"></div></div>
                                    </div>
                                    <div id="o1w"></div>
                                </div>
                                <div class="card">
                                    <div class="card-hd"><i></i><span>年龄分布</span><em class="src real">接口数据</em>
                                        <div class="hd-seg">
                                            <div class="ss-seg age-seg" id="ageSeg">
                                                <span v-for="g in AGE_SEG" :key="g.k" class="ss-btn"
                                                      :class="{ on: ageView === g.k }" @click="changeAgeView(g.k)">{{ g.n }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div id="t2" class="chart ov-c2"></div>
                                    <div class="note" v-if="ov.teacher">专任教师 <b>{{ ov.teacher.teacherCount }}</b> 人（男 {{ ov.teacher.manTeacherCount }} / 女 {{ ov.teacher.womanTeacherCount }}）
                                        · 小学 {{ pval('小学') }} / 初中 {{ pval('初中') }} / 高中 {{ pval('高中') }} / 其他 {{ pval('其他') }}
                                    </div>
                                </div>
                            </div>
                            <div class="ov-col ov-c">
                                <div class="card">
                                    <div class="card-hd"><i></i><span>大同市 · 教研资源分布地图</span><em class="src real">接口数据</em></div>
                                    <div class="ov-body">
                                        <div class="ov-map" id="ovMap"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="ov-col">
                                <div class="card">
                                    <div class="card-hd"><i></i><span>学科教研均衡度</span><em class="src real">接口数据</em></div>
                                    <div id="o6b"></div>
                                </div>
                                <div class="card">
                                    <div class="card-hd"><i></i><span>学校教研活跃度 TOP 8</span><em class="src real">接口数据</em></div>
                                    <div id="o3" class="chart"></div>
                                </div>
                            </div>
                        </div>
                        <div class="ov-bottom">
                            <div class="card">
                                <div class="card-hd"><i></i><span>教师性别分布</span></div>
                                <div class="ds-wrap">
                                    <div class="ds-chart" id="t3"></div>
                                    <div class="ds-legend">
                                        <div v-for="(it, i) in genderLegend" :key="'g' + i" class="ds-item">
                                            <i :style="{ background: DONUT_COLORS[i % DONUT_COLORS.length] }"></i>
                                            <div class="ds-txt"><span>{{ it.name }}</span><b>{{ it.pct }}%</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>教师职称分布</span></div>
                                <div class="ds-wrap">
                                    <div class="ds-chart" id="t4"></div>
                                    <div class="ds-legend">
                                        <div v-for="(it, i) in rankLegend" :key="'r' + i" class="ds-item">
                                            <i :style="{ background: DONUT_COLORS[i % DONUT_COLORS.length] }"></i>
                                            <div class="ds-txt"><span>{{ it.name }}</span><b>{{ it.pct }}%</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>教师学历分布</span></div>
                                <div class="ds-wrap">
                                    <div class="ds-chart" id="t5"></div>
                                    <div class="ds-legend">
                                        <div v-for="(it, i) in eduLegend" :key="'e' + i" class="ds-item">
                                            <i :style="{ background: DONUT_COLORS[i % DONUT_COLORS.length] }"></i>
                                            <div class="ds-txt"><span>{{ it.name }}</span><b>{{ it.pct }}%</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>一体化教研构成</span></div>
                                <div class="ds-wrap">
                                    <div class="ds-chart" id="o4"></div>
                                    <div class="ds-legend">
                                        <div v-for="(it, i) in integrateLegend" :key="'i' + i" class="ds-item">
                                            <i :style="{ background: DONUT_COLORS[i % DONUT_COLORS.length] }"></i>
                                            <div class="ds-txt"><span>{{ it.name }}</span><b>{{ it.pct }}%</b></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>近 12 月教研活跃度趋势</span><em class="src real">接口数据</em></div>
                                <div id="o2" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>教师画像建档 · 分学校</span><em class="src real">接口数据</em></div>
                                <div id="t7" class="chart"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板2：名师工作室驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-studio-mst" v-show="activePanel === 'studio-mst'" v-loading="loading.studioMst">
                    <div class="mst-tabpane" v-show="mstTab === 't1'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员学科分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="ms1seg"></div></div>
                                </div>
                                <div id="ms1w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员骨干占比</span><em class="src real">接口数据</em></div>
                                <div id="ms2" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 工作室概览</span><em class="src real">接口数据</em></div>
                                <div id="ms0w" v-html="mstWaterKpi"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员规模趋势（按季度）</span><em class="src real">接口数据</em></div>
                                <div id="ms3" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>工作室层级分布</span><em class="src real">接口数据</em></div>
                                <div id="ms10" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>各工作室活动承办量</span><em class="src real">接口数据</em></div>
                                <div id="ms8" class="chart"></div>
                            </div>
                        </div>
                    </div>
                    <div class="mst-tabpane" v-show="mstTab === 't2'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果学科分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="ms5seg"></div></div>
                                </div>
                                <div id="ms5w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果类型分布</span><em class="src real">接口数据</em></div>
                                <div id="ms4" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 工作室概览</span><em class="src real">接口数据</em></div>
                                <div id="ms9w" v-html="mstWaterKpiT2"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果总量趋势（按年）</span><em class="src real">接口数据</em></div>
                                <div id="ms6" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>TOP 工作室排行（按成员）</span><em class="src real">接口数据</em></div>
                                <div id="ms7" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>工作室清单</span><em class="src real">接口数据</em></div>
                                <div class="tbl-wrap" v-html="mstRowsHtml"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板3：名校长工作室驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-studio-pr" v-show="activePanel === 'studio-pr'" v-loading="loading.studioPr">
                    <div class="mst-tabpane" v-show="prTab === 't1'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员主题分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="pr1seg"></div></div>
                                </div>
                                <div id="pr1w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员骨干占比</span><em class="src real">接口数据</em></div>
                                <div id="pr2" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 工作室概览</span><em class="src real">接口数据</em></div>
                                <div id="pr0w" v-html="prWaterKpi"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成员规模趋势（按季度）</span><em class="src real">接口数据</em></div>
                                <div id="pr3" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>工作室层级分布</span><em class="src real">接口数据</em></div>
                                <div id="pr10" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>各工作室活动承办量</span><em class="src real">接口数据</em></div>
                                <div id="pr8" class="chart"></div>
                            </div>
                        </div>
                    </div>
                    <div class="mst-tabpane" v-show="prTab === 't2'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果主题分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="pr5seg"></div></div>
                                </div>
                                <div id="pr5w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果类型分布</span><em class="src real">接口数据</em></div>
                                <div id="pr4" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 工作室概览</span><em class="src real">接口数据</em></div>
                                <div id="pr9w" v-html="prWaterKpiT2"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>成果总量趋势（按年）</span><em class="src real">接口数据</em></div>
                                <div id="pr6" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>TOP 工作室排行（按成员）</span><em class="src real">接口数据</em></div>
                                <div id="pr7" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>工作室清单</span><em class="src real">接口数据</em></div>
                                <div class="tbl-wrap" v-html="prRowsHtml"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板4：一体化教研驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-eva" v-show="activePanel === 'eva'" v-loading="loading.eva">
                    <div class="eva-main">
                        <div class="eva-col">
                            <div class="card">
                                <div class="card-hd"><i></i><span>教龄 × 学科分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg e6-seg">
                                        <span v-for="s in STAGE_SEG" :key="s.k" class="ss-btn" :class="{ on: e6Stage === s.k }"
                                              @click="changeEvaStage('e6', s.k)">{{ s.n }}</span>
                                    </div></div>
                                </div>
                                <div id="e6" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>近期听评课课例榜（Top 8）</span><em class="src real">接口数据</em></div>
                                <div class="tbl-scroll" v-html="evaLessonsHtml"></div>
                            </div>
                        </div>
                        <div class="eva-col eva-c">
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 教研概况</span><em class="src real">接口数据</em></div>
                                <div class="eva-kpis">
                                    <div v-for="(k, i) in evaKpis" :key="'ek' + i" class="eva-kpi">
                                        <div class="num" :style="{ color: k.color }">{{ k.v }}</div>
                                        <div class="lab">{{ k.l }}</div>
                                        <span v-if="k.sub" class="sub">{{ k.sub }}</span>
                                        <svg width="104" height="60" viewBox="0 0 180 106" v-html="evaRing(k.color, k.u)"></svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="eva-col">
                            <div class="card">
                                <div class="card-hd"><i></i><span>月度听评课趋势</span><em class="src real">接口数据</em></div>
                                <div id="e4" class="chart lg"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>授课教师年龄分布</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg e5-seg">
                                        <span v-for="s in STAGE_SEG" :key="s.k" class="ss-btn" :class="{ on: e5Stage === s.k }"
                                              @click="changeEvaStage('e5', s.k)">{{ s.n }}</span>
                                    </div></div>
                                </div>
                                <div id="e5" class="chart lg"></div>
                            </div>
                        </div>
                    </div>
                    <div class="grid g3">
                        <div class="card">
                            <div class="card-hd"><i></i><span>听评课方式分布</span><em class="src real">接口数据</em></div>
                            <div id="e1" class="chart"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>评课学科分布</span><em class="src real">接口数据</em>
                                <div class="hd-seg"><div class="ss-seg" id="e2seg"></div></div>
                            </div>
                            <div id="e2w"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>听课人次（按学科）</span><em class="src real">接口数据</em>
                                <div class="hd-seg"><div class="ss-seg" id="e3seg"></div></div>
                            </div>
                            <div id="e3w"></div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板5：教科研驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-research" v-show="activePanel === 'research'" v-loading="loading.research">
                    <!-- 课题引领：设计稿同款 ISO 三栏 6 卡 -->
                    <div class="mst-tabpane" v-show="rsTab === 't1'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>课题来源结构</span><em class="src real">接口数据</em></div>
                                <div id="r1" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>课题级别分布</span><em class="src real">接口数据</em></div>
                                <div id="r2" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 教科研概览</span><em class="src real">接口数据</em></div>
                                <div id="r0w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>课题分类分布</span><em class="src real">接口数据</em></div>
                                <div id="r3" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>立项 / 成果趋势（按季度）</span><em class="src real">接口数据</em></div>
                                <div id="r5" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>引领主课题清单（含子课题配额）</span><em class="src real">接口数据</em></div>
                                <div class="tbl-wrap" v-html="topicRowsHtml"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 教研赛事 -->
                    <div class="mst-tabpane" v-show="rsTab === 't2'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>竞赛级别分布</span><em class="src real">接口数据</em></div>
                                <div id="race1" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>报名学科 TOP</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="race6seg"></div></div>
                                </div>
                                <div id="race6w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 教科研概览</span><em class="src real">接口数据</em></div>
                                <div id="race0w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>近 12 个月 竞赛 / 报名 / 获奖趋势</span><em class="src real">接口数据</em></div>
                                <div id="race3" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>获奖奖级分布</span><em class="src real">接口数据</em></div>
                                <div id="race8" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>竞赛明细（按报名人次排序）</span><em class="src real">接口数据</em></div>
                                <div class="tbl-wrap" v-html="eventRowsHtml('race')"></div>
                            </div>
                        </div>
                    </div>
                    <!-- 专题活动 -->
                    <div class="mst-tabpane" v-show="rsTab === 't3'">
                        <div class="mst-iso-grid">
                            <div class="card">
                                <div class="card-hd"><i></i><span>活动级别分布</span><em class="src real">接口数据</em></div>
                                <div id="actv1" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>报名学科 TOP</span><em class="src real">接口数据</em>
                                    <div class="hd-seg"><div class="ss-seg" id="actv6seg"></div></div>
                                </div>
                                <div id="actv6w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>核心指标 · 教科研概览</span><em class="src real">接口数据</em></div>
                                <div id="actv0w"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>近 12 个月 活动 / 报名 / 获奖趋势</span><em class="src real">接口数据</em></div>
                                <div id="actv3" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>获奖奖级分布</span><em class="src real">接口数据</em></div>
                                <div id="actv8" class="chart"></div>
                            </div>
                            <div class="card">
                                <div class="card-hd"><i></i><span>活动明细（按报名人次排序）</span><em class="src real">接口数据</em></div>
                                <div class="tbl-wrap" v-html="eventRowsHtml('actv')"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板6：资源中心驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-resource" v-show="activePanel === 'resource'" v-loading="loading.resource">
                    <div class="mst-iso-grid">
                        <div class="card">
                            <div class="card-hd"><i></i><span>名师优课 · 月度上架量与查看量</span><em class="src real">接口数据</em></div>
                            <div id="s2" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>各类型课程 查看量 / 点赞量</span><em class="src real">接口数据</em></div>
                            <div id="s3" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>核心指标 · 资源概览</span><em class="src real">接口数据</em></div>
                            <div id="s0w" class="res-dishes" v-html="resDishesHtml"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>热门课程 TOP 10（查看 / 点赞 / 收藏）</span><em class="src real">接口数据</em></div>
                            <div id="s4" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>组卷月度趋势（近 12 月）</span><em class="src real">接口数据</em></div>
                            <div id="s6w" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>名师优课课程明细（按查看量降序）</span><em class="src real">接口数据</em></div>
                            <div class="tbl-wrap" v-html="resourceRowsHtml"></div>
                        </div>
                    </div>
                </div>

                <!-- ==================== 面板7：师资培训驾驶舱 ==================== -->
                <div class="panel ov-dark" id="panel-train" v-show="activePanel === 'train'" v-loading="loading.train">
                    <div class="mst-iso-grid">
                        <div class="card">
                            <div class="card-hd"><i></i><span>各培训主题看课人次</span><em class="src real">接口数据</em></div>
                            <div id="tr1" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>学习进度分布（按人数）</span><em class="src real">接口数据</em></div>
                            <div id="tr2" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>核心指标 · 培训概览</span><em class="src real">接口数据</em></div>
                            <div id="tr0w" class="net-wrap" v-html="trainNetworkHtml"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>课程点击率 TOP 10</span><em class="src real">接口数据</em></div>
                            <div id="tr4" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>课程完课情况（各课程 · 人数）</span><em class="src real">接口数据</em></div>
                            <div id="tr3" class="chart lg"></div>
                        </div>
                        <div class="card">
                            <div class="card-hd"><i></i><span>培训课程明细</span><em class="src real">接口数据</em></div>
                            <div class="tbl-wrap" v-html="trainRowsHtml"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from "echarts";
import { ElLoading } from "element-plus";
import { listUserManagerOrgNew } from "@/api/admin/system";
import {
    areaCockpitOverview,
    areaCockpitEva,
    areaCockpitResearch,
    areaCockpitStudio,
    areaCockpitResource,
    areaCockpitTrain
} from "@/api/admin/areaCockpit";
import datongGeo from "@/assets/map/datong.json";

const PAL = ['#68bbc4', '#5087ec', '#ffbf6b', '#3ba272', '#ed6616', '#f39423', '#f9c78b', '#8f7cf5', '#5ad1e6', '#c2e36b'];
/* 设计稿基准尺寸：整页固定为 1920×1080，再按窗口大小整体 scale，
   适配任意 PC 屏幕；浏览器缩放只改变 scale 值，布局比例恒定不变 */
const DESIGN_W = 1920, DESIGN_H = 1080;
const AX = {
    axisLine: { lineStyle: { color: 'rgba(255,255,255,.4)' } },
    axisTick: { show: false },
    axisLabel: { color: '#e6efff', fontSize: 11 },
    splitLine: { lineStyle: { color: 'rgba(255,255,255,.13)' } }
};

export default {
    name: "areaDashboard",
    data() {
        return {
            PANELS: [
                { key: 'overview', name: '区域教研总览' },
                { key: 'studio-mst', name: '名师工作室驾驶舱' },
                { key: 'studio-pr', name: '名校长工作室驾驶舱' },
                { key: 'eva', name: '一体化教研驾驶舱' },
                { key: 'research', name: '教科研驾驶舱' },
                { key: 'resource', name: '资源中心驾驶舱' },
                { key: 'train', name: '师资培训驾驶舱' }
            ],
            MENU_ICONS: {
                'overview': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="3.2" y="3.2" width="7.4" height="7.4" rx="1.8"/><rect x="13.4" y="3.2" width="7.4" height="7.4" rx="1.8"/><rect x="3.2" y="13.4" width="7.4" height="7.4" rx="1.8"/><rect x="13.4" y="13.4" width="7.4" height="7.4" rx="1.8"/></svg>',
                'studio-mst': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.1" cy="8.1" r="3.4"/><path d="M3.7 20.2c.5-3.6 3.2-5.7 6.4-5.7 1.1 0 2.1.3 3 .8"/><path d="M18 13.1l1.15 2.32 2.56.37-1.85 1.8.44 2.55-2.3-1.2-2.3 1.2.44-2.55-1.85-1.8 2.56-.37z"/></svg>',
                'studio-pr': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 20.4h16"/><path d="M6.2 20.4V10l5.8-3.2 5.8 3.2v10.4"/><path d="M10.2 20.4v-4.2h3.6v4.2"/><path d="M12 6.8V3.6"/></svg>',
                'eva': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M9.6 14.4l4.8-4.8"/><path d="M11.1 6.9l1.7-1.7a3.7 3.7 0 015.2 5.2l-1.7 1.7"/><path d="M12.9 17.1l-1.7 1.7a3.7 3.7 0 01-5.2-5.2l1.7-1.7"/></svg>',
                'research': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><circle cx="10.6" cy="10.6" r="6.1"/><path d="M15.2 15.2l4.6 4.6"/></svg>',
                'resource': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3.4 7A2.4 2.4 0 015.8 4.6h3.3l2 2.4h7.1A2.4 2.4 0 0120.6 9.4v8A2.4 2.4 0 0118.2 19.8H5.8A2.4 2.4 0 013.4 17.4z"/></svg>',
                'train': '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4.4l8.6 4.2L12 12.8 3.4 8.6z"/><path d="M7 11.2v4.6c0 1.6 2.24 2.9 5 2.9s5-1.3 5-2.9v-4.6"/></svg>'
            },
            DONUT_COLORS: ['#5087ec', '#ffbf6b', '#68bbc4', '#3ba272', '#ed6616', '#8f7cf5', '#f39423', '#f9c78b'],
            AGE_SEG: [{ k: 'all', n: '全部' }, { k: 'male', n: '男' }, { k: 'female', n: '女' }],
            STAGE_SEG: [{ k: 'all', n: '全部' }, { k: 'xx', n: '小学' }, { k: 'cz', n: '初中' }, { k: 'gz', n: '高中' }],
            activePanel: 'overview',
            sideCollapsed: false,
            fitStyle: {},
            orgList: [],
            orgId: '',
            meta: { orgName: '区域教科研中心', base: '教研驾驶舱 · 区域教科研数据中枢' },
            loading: { overview: false, studioMst: false, studioPr: false, eva: false, research: false, resource: false, train: false },
            ov: {},
            ageView: 'all',
            mstTab: 't1', prTab: 't1', rsTab: 't1',
            mst: {}, pr: {},
            evaData: {},
            e5Stage: 'all', e6Stage: 'all',
            research: {},
            res: {},
            trainData: {},
            charts: {}
        };
    },
    computed: {
        panelName() {
            const p = this.PANELS.find(x => x.key === this.activePanel);
            return p ? p.name : '';
        },
        /* 顶部核心指标横条：合并原地图两侧的 KPI 数据（左列 + 右列） */
        ovKpiStrip() { return (this.ov.kpiLeft || []).concat(this.ov.kpiRight || []); },
        genderLegend() { return this.pctList(this.ov.teacher && this.ov.teacher.gender); },
        rankLegend() { return this.pctList(this.ov.teacher && this.ov.teacher.rank); },
        eduLegend() { return this.pctList(this.ov.teacher && this.ov.teacher.edu); },
        integrateLegend() { return this.pctList(this.ov.integrate); },
        evaKpis() {
            const e = this.evaData || {};
            return [
                { v: e.evaCount || 0, l: '听评课总数', u: '节', color: '#55e0ff' },
                { v: e.teaCount || 0, l: '授课教师', u: '人', color: '#46d08a' },
                { v: e.evaTeacherCount || 0, l: '参与评课教师', u: '人', color: '#ffd04d', sub: '含线上 ' + (e.onlineEvaCount || 0) + ' 节' },
                { v: e.evaPeopleCount || 0, l: '累计听课人次', u: '次', color: '#ff6b9d' },
                { v: e.integrateCount || 0, l: '集体备课', u: '节', color: '#8f7cf5', sub: '新增项' }
            ];
        },
        /* 核心指标 · 教科研概览（三个 Tab 共用，喂给 techKpis 的四组数据） */
        researchKpiItems() {
            const r = this.research || {};
            const rc = r.race || {}, ac = r.actv || {};
            /* 成果副指标：优先取「文章」类成果，字典无此项时退化为数量最多的成果类型 */
            const at = r.achieveByType || { labels: [], values: [] };
            const labels = at.labels || [], values = at.values || [];
            let ax = labels.indexOf('文章'), mx = -1;
            if (ax < 0) {
                values.forEach((v, i) => { if (v > mx) { mx = v; ax = i; } });
            }
            const aLab = ax > -1 ? labels[ax] : '成果';
            const aVal = ax > -1 ? values[ax] : 0;
            return [
                ['教科研成果', r.achieveTotal || 0, '项', '#8f7cf5', aLab + ' <b>' + aVal + '</b>'],
                ['各级课题总数', r.topicTotal || 0, '项', '#55e0ff',
                    '主课题 <b>' + (r.hostTopic || 0) + '</b> / 子课题 <b>' + (r.leadTopic || 0) + '</b>'],
                ['专题活动', ac.total || 0, '场', '#ff6b9d', '服务 <b>' + (ac.signCount || 0) + '</b> 人次'],
                ['教研赛事', rc.total || 0, '场', '#ffd04d', '报名 <b>' + (rc.signCount || 0) + '</b> 人次']
            ];
        },
        topicRowsHtml() {
            const rows = (this.research && this.research.topicRows) || [];
            return this.tableHtml(['课题名称', '级别', '分类', '子课题数', '状态'],
                rows.map(r => [this.ell(r[0]), r[1], r[2], r[3], this.badge(r[4])]));
        },
        mstRowsHtml() { return this.studioRowsHtml(this.mst); },
        prRowsHtml() { return this.studioRowsHtml(this.pr); },
        resourceRowsHtml() {
            const rows = (this.res && this.res.rows) || [];
            return this.tableHtml(['课程名称', '类型', '学科', '学段', '查看量', '点赞', '收藏'],
                rows.map(r => [this.ell(r[0]), r[1], r[2], r[3], this.num(r[4]), this.num(r[5]), this.num(r[6])]));
        },
        trainRowsHtml() {
            const rows = (this.trainData && this.trainData.rows) || [];
            return this.tableHtml(['课程', '培训类型', '范围', '看课人数', '完课率', '点击率', '热度'],
                rows.map(r => [this.ell(r[0]), r[1], r[2], this.num(r[3]), r[4], r[5], this.badge(r[6])]));
        },
        evaLessonsHtml() {
            const rows = (this.evaData && this.evaData.lessons) || [];
            return this.tableHtml(['课题', '学科', '学段', '方式', '学校'],
                rows.map(r => [this.ell(r.title), r.subject, r.period, r.type, r.school]));
        },
        resDishesHtml() {
            const r = this.res || {};
            const items = [
                [r.courseTotal, '门', '名师优课课程', '#ffd04d'],
                [r.viewTotal, '次', '课程总查看', '#55e0ff'],
                [r.likeTotal, '个', '总点赞', '#46d08a'],
                [r.collectTotal, '个', '总收藏', '#8f7cf5'],
                [r.paperTotal, '套', '题库组卷', '#ff6b9d'],
                [r.eceRes, '个', '幼教资源', '#ff9f43']
            ];
            return items.map((it, i) => this.dishRing(it[3], this.fmtNum(it[0]), it[1], it[2], i)).join('');
        },
        mstWaterKpi() { return this.waterKpis(this.mst, 'a'); },
        mstWaterKpiT2() { return this.waterKpis(this.mst, 'b'); },
        prWaterKpi() { return this.waterKpis(this.pr, 'c'); },
        prWaterKpiT2() { return this.waterKpis(this.pr, 'd'); },
        trainNetworkHtml() {
            const t = this.trainData || {};
            const pd = t.pushdoor || {};
            const items = [
                [t.courseTotal || 0, '门', '培训课程总数'],
                [t.trainee || 0, '人', '参训教师'],
                [Math.round((t.courseViews || 0) / 10000 * 10) / 10 + '万', '人次', '总看课人次'],
                [(t.avgComplete || 0) + '%', '', '平均完课率'],
                [Math.round((t.clickTotal || 0) / 10000 * 10) / 10 + '万', '次', '课程总点击'],
                [pd.sessions || 0, '场', '推门培训'],
                [pd.trainee || 0, '人次', '推门培训参训']
            ];
            return this.networkKpis('trn', items);
        }
    },
    created() {
        /* getOrgList 内的 ElLoading.service 若在 created 同步执行，会破坏 Vue 的
           currentInstance 追踪，导致本组件 beforeMount/mounted 静默不触发；
           推迟到宏任务，待挂载流程全部完成后再发起加载 */
        setTimeout(() => this.getOrgList(), 0);
    },
    mounted() {
        this.updateScale();
        window.addEventListener('resize', this.onResize);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.onResize);
        this.disposeCharts();
    },
    methods: {
        pval(k) {
            return (this.ov.teacher && this.ov.teacher.period) ? this.ov.teacher.period[k] : 0;
        },
        pctList(pair) {
            if (!pair || !pair.values) return [];
            const total = pair.values.reduce((a, b) => a + b, 0) || 1;
            return pair.labels.map((l, i) => ({ name: l, pct: Math.round(pair.values[i] / total * 100) }));
        },
        onResize() { this.updateScale(); this.resizeAll(); },
        /* 整页缩放：窗口尺寸或浏览器缩放（Ctrl+滚轮）变化时重算 scale。
           容器布局尺寸恒为 1920×1080，仅视觉缩放，布局永不重排 */
        updateScale() {
            const sx = window.innerWidth / DESIGN_W;
            const sy = window.innerHeight / DESIGN_H;
            this.fitStyle = { transform: 'scale(' + sx + ',' + sy + ')' };
        },
        resizeAll() {
            Object.values(this.charts).forEach(c => {
                try { c.resize(); } catch (e) {}
                try {
                    const opt = c.getOption();
                    if (opt && (opt.series || []).some(s => s.type === 'pie')) this.pieFix(c);
                } catch (e) {}
            });
        },
        disposeCharts() { Object.values(this.charts).forEach(c => { try { c.dispose(); } catch (e) {} }); this.charts = {}; },

        /* ---------------- 组织 ---------------- */
        getOrgList() {
            const loading = ElLoading.service({ fullscreen: true });
            listUserManagerOrgNew().then(res => {
                if (res.data.code === 1) {
                    this.orgList = res.data.data || [];
                    if (this.orgList.length) {
                        const orgInfo = this.orgList[0];
                        this.orgId = orgInfo.orgId;
                        this.meta.orgName = orgInfo.orgName || this.meta.orgName;
                        this.loadAll();
                    }
                    loading.close();
                } else {
                    this.$message.error("服务异常");
                    loading.close();
                }
            }).catch(() => loading.close());
        },
        onOrgChange(id) {
            const info = this.orgList.find(e => e.orgId === id);
            if (info) { this.meta.orgName = info.orgName || this.meta.orgName; }
            this.loadAll();
        },
        switchPanel(key) {
            this.activePanel = key;
            this.$nextTick(() => { this.renderPanel(key); this.resizeAll(); });
        },
        switchTab(panel, tab) {
            if (panel === 'studio-mst') { this.mstTab = tab; this.$nextTick(() => this.drawMst()); }
            else if (panel === 'studio-pr') { this.prTab = tab; this.$nextTick(() => this.drawPr()); }
            else { this.rsTab = tab; this.$nextTick(() => this.drawResearch()); }
        },
        toggleSide() {
            this.sideCollapsed = !this.sideCollapsed;
            setTimeout(() => this.resizeAll(), 320);
        },
        loadAll() {
            this.loadOverview();
            this.loadEva();
            this.loadResearch();
            this.loadStudio('mst');
            this.loadStudio('pr');
            this.loadResource();
            this.loadTrain();
        },

        /* ---------------- 接口 ---------------- */
        loadOverview() {
            this.loading.overview = true;
            areaCockpitOverview({ orgId: this.orgId }).then(res => {
                if (res.data.code === 1) {
                    this.ov = res.data.data || {};
                    /* 待 KPI 数据条、专任教师备注等数据驱动 DOM 渲染完成后再落图，
                       否则地图（flex 自适应高度）等图表会按旧布局量到错误尺寸，首屏样式错乱 */
                    this.$nextTick(() => { this.drawOverview(); this.resizeAll(); });
                }
                this.loading.overview = false;
            }).catch(() => { this.loading.overview = false; });
        },
        loadEva() {
            this.loading.eva = true;
            areaCockpitEva({ orgId: this.orgId }).then(res => {
                if (res.data.code === 1) { this.evaData = res.data.data || {}; this.drawEva(); }
                this.loading.eva = false;
            }).catch(() => { this.loading.eva = false; });
        },
        loadResearch() {
            this.loading.research = true;
            areaCockpitResearch({ orgId: this.orgId }).then(res => {
                if (res.data.code === 1) {
                    this.research = res.data.data || {};
                    /* 待 v-show 的 Tab 面板完成渲染后再落图，避免容器尺寸为 0 */
                    this.$nextTick(() => this.drawResearch());
                }
                this.loading.research = false;
            }).catch(() => { this.loading.research = false; });
        },
        loadStudio(kind) {
            const isMst = kind === 'mst';
            this.loading[isMst ? 'studioMst' : 'studioPr'] = true;
            areaCockpitStudio({ orgId: this.orgId, type: isMst ? '2' : '3' }).then(res => {
                if (res.data.code === 1) {
                    if (isMst) { this.mst = res.data.data || {}; this.drawMst(); }
                    else { this.pr = res.data.data || {}; this.drawPr(); }
                }
                this.loading[isMst ? 'studioMst' : 'studioPr'] = false;
            }).catch(() => { this.loading[isMst ? 'studioMst' : 'studioPr'] = false; });
        },
        loadResource() {
            this.loading.resource = true;
            areaCockpitResource({ orgId: this.orgId }).then(res => {
                if (res.data.code === 1) { this.res = res.data.data || {}; this.drawResource(); }
                this.loading.resource = false;
            }).catch(() => { this.loading.resource = false; });
        },
        loadTrain() {
            this.loading.train = true;
            areaCockpitTrain({ orgId: this.orgId }).then(res => {
                if (res.data.code === 1) { this.trainData = res.data.data || {}; this.drawTrain(); }
                this.loading.train = false;
            }).catch(() => { this.loading.train = false; });
        },
        renderPanel(key) {
            if (key === 'overview') this.drawOverview();
            else if (key === 'eva') this.drawEva();
            else if (key === 'research') this.drawResearch();
            else if (key === 'studio-mst') this.drawMst();
            else if (key === 'studio-pr') this.drawPr();
            else if (key === 'resource') this.drawResource();
            else if (key === 'train') this.drawTrain();
        },

        /* ---------------- 图表基础 ---------------- */
        mk(id, option) {
            const el = document.getElementById(id);
            if (!el) return null;
            if (this.charts[id]) { try { this.charts[id].dispose(); } catch (e) {} }
            /* 清掉可能残留的空状态占位，避免 ECharts 与占位内容并存 */
            el.innerHTML = '';
            const c = echarts.init(el);
            c.setOption(option);
            this.charts[id] = c;
            /* 饼图需抵消整页非等比缩放，保证视觉上恒为正圆 */
            if ((option.series || []).some(s => s.type === 'pie')) this.pieFix(c);
            return c;
        },
        /* 整页按 scale(sx, sy) 非等比缩放，窗口宽高比非 16:9 时正圆会被拉成椭圆。
           对饼图内层画布施加反向变换：最终缩放变为 min(sx, sy) 等比，饼图恒为正圆。
           只缩不扩（系数 ≤ 1），以中心为原点，不会溢出卡片或挤压图例 */
        pieFix(c) {
            try {
                const sx = window.innerWidth / DESIGN_W, sy = window.innerHeight / DESIGN_H;
                const inner = c.getDom() && c.getDom().firstElementChild;
                if (inner) {
                    inner.style.transformOrigin = 'center center';
                    inner.style.transform = 'scale(' + Math.min(1, sy / sx) + ',' + Math.min(1, sx / sy) + ')';
                }
            } catch (e) {}
        },
        /* 图表空状态占位：销毁旧实例并以文字提示代替（避免全 0 数据渲染成空白块） */
        emptyBox(id, text) {
            if (this.charts[id]) { try { this.charts[id].dispose(); } catch (e) {} delete this.charts[id]; }
            const el = document.getElementById(id);
            if (el) el.innerHTML = '<div class="empty-tip">' + (text || '暂无数据') + '</div>';
        },
        /**
         * 中间省略：超过 max 个字符时保留「前 3 / 后 2 + 中间省略号」，总长恒为 max。
         * 截断前先去掉首尾孤立标点，避免出现「数学核…感）」这种只剩右括号的别扭结果。
         * 例：midEllipsis('数学核心素养与素养表现（量感）', 6) → '数学核…量感'
         */
        midEllipsis(str, max) {
            const n = max || 6;
            /* 去掉首尾标点/符号：\p{P} 标点 \p{S} 符号，避免截出「数学核…感）」这种只剩右括号的结果 */
            const s = String(str == null ? '' : str)
                .replace(/^[\p{P}\p{S}\s]+/u, '')
                .replace(/[\p{P}\p{S}\s]+$/u, '');
            if (s.length <= n) return s;
            const head = Math.max(1, Math.round((n - 1) * 3 / 5));
            const tail = Math.max(0, n - 1 - head);
            /* 切点可能落在空格上（如「数学 六年级 …」），去掉再拼，避免「数学 …问题」这种前导空格 */
            return s.slice(0, head).replace(/\s+$/, '')
                + '…'
                + (tail ? s.slice(s.length - tail).replace(/^\s+/, '') : '');
        },
        /**
         * Y 轴类目名被省略号截断后，把全称挂到容器原生 title 上：
         * 鼠标悬停轴标签即显示浏览器提示（柱体 tooltip 本就用全称，两者互补）。
         * 需配合 axisLabel.triggerEvent = true 才能收到 axis 标签的 mouseover。
         */
        bindAxisTitle(chart, names) {
            if (!chart) return;
            const tip = raw => {
                const el = chart.getDom();
                if (!el) return;
                if (raw) el.setAttribute('title', raw); else el.removeAttribute('title');
            };
            chart.on('mouseover', p => {
                if (!p || p.componentType !== 'yAxis') { tip(null); return; }
                const raw = p.value != null ? p.value : (names || [])[p.dataIndex];
                tip(raw);
            });
            chart.on('mouseout', () => tip(null));
            /* 滚动/重绘时清掉残留提示，避免悬停在已销毁的标签上仍显示旧全称 */
            chart.on('globalout', () => tip(null));
        },
        optLine(cats, series, palette) {
            return {
                color: palette || PAL,
                grid: { left: 8, right: 16, top: 36, bottom: 4, containLabel: true },
                tooltip: { trigger: 'axis', backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                legend: { top: 0, itemWidth: 12, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                xAxis: Object.assign({ type: 'category', boundaryGap: false, data: cats }, AX),
                yAxis: Object.assign({ type: 'value' }, AX),
                series: series.map(s => Object.assign({ type: 'line', smooth: true, symbolSize: 6, lineStyle: { width: 2.4 }, areaStyle: { opacity: .16 } }, s))
            };
        },
        optBar(cats, vals, color, opt) {
            opt = opt || {};
            const o = {
                grid: { left: 8, right: 14, top: 26, bottom: 4, containLabel: true },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                xAxis: Object.assign({ type: 'category', data: cats }, AX),
                yAxis: Object.assign({ type: 'value' }, AX),
                series: [{
                    type: 'bar', data: vals, barMaxWidth: 26,
                    label: { show: true, position: 'top', color: '#fff', fontSize: 11, formatter: opt.fmt || '{c}' },
                    itemStyle: { borderRadius: [4, 4, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: color }, { offset: 1, color: 'rgba(255,255,255,.22)' }]) }
                }]
            };
            if (opt.rotate) o.xAxis.axisLabel = Object.assign({}, AX.axisLabel, { rotate: opt.rotate });
            return o;
        },
        optBarH(cats, vals, color, bw, opt) {
            opt = opt || {};
            const yAxis = Object.assign({ type: 'category', data: cats, inverse: true }, AX);
            if (opt.labelMax) {
                /* Y 轴类目名超长时中间加省略号；data 仍保留全称 → 柱体 tooltip 显示全称，
                   轴标签 hover 由 bindAxisTitle 挂原生 title 显示全称 */
                yAxis.axisLabel = Object.assign({}, AX.axisLabel, {
                    triggerEvent: true,
                    formatter: v => this.midEllipsis(v, opt.labelMax)
                });
            }
            return {
                grid: { left: 8, right: 36, top: 14, bottom: 4, containLabel: true },
                /* confine: 全称 tooltip 较长，限制在图表容器内避免被卡片 overflow:hidden 裁掉 */
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, confine: true, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                xAxis: Object.assign({ type: 'value' }, AX),
                yAxis: yAxis,
                series: [{
                    type: 'bar', data: vals, barMaxWidth: (bw || 18), label: { show: true, position: 'right', color: '#fff', fontSize: 11 },
                    itemStyle: { borderRadius: [0, 4, 4, 0], color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{ offset: 0, color: 'rgba(255,255,255,.22)' }, { offset: 1, color: color }]) }
                }]
            };
        },
        /* 漏斗（流程推进用）：sort:'none' 保持传入顺序，不被 ECharts 按数值重排 */
        optFunnel(cats, vals, colors, unit) {
            return {
                color: colors || ['#5087ec', '#68bbc4', '#ffbf6b', '#8f7cf5'],
                tooltip: { trigger: 'item', backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 }, formatter: '{b}: {c} ' + (unit || '件') },
                series: [{
                    type: 'funnel', left: '7%', right: '7%', top: 12, bottom: 8, minSize: '34%', gap: 3, sort: 'none',
                    label: { color: '#fff', fontSize: 11, position: 'inside', formatter: '{b} {c}' },
                    itemStyle: { borderColor: 'rgba(10,35,80,.85)', borderWidth: 1 },
                    data: cats.map((c, i) => ({ name: c, value: vals[i] || 0 }))
                }]
            };
        },
        optDonut(data, opt) {
            opt = opt || {};
            /* 指定 formatter 时保留标签（实心饼也显示文字），否则实心饼只留图形 */
            const showLabel = opt.formatter != null || !opt.solid;
            return {
                color: (opt.colors || PAL),
                tooltip: { trigger: 'item', backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 }, formatter: '{b}<br/>{c} ({d}%)' },
                legend: opt.hideLegend ? { show: false } : { bottom: 0, itemWidth: 10, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                series: [{
                    type: 'pie', radius: opt.radius || (opt.solid ? '88%' : ['42%', '66%']), center: opt.center || ['50%', '45%'],
                    roseType: opt.rose ? 'radius' : false, avoidLabelOverlap: true,
                    itemStyle: { borderColor: '#2076ff', borderWidth: 2 },
                    label: { show: showLabel, color: '#eaf2ff', fontSize: 11, formatter: opt.formatter || '{b}\n{c}' },
                    labelLine: { show: showLabel, lineStyle: { color: 'rgba(255,255,255,.5)' }, length: 6, length2: 8 },
                    data: data
                }]
            };
        },
        optStack(cats, series, bw) {
            return {
                color: PAL,
                grid: { left: 8, right: 16, top: 36, bottom: 4, containLabel: true },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                legend: { top: 0, itemWidth: 12, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                xAxis: Object.assign({ type: 'category', data: cats }, AX),
                yAxis: Object.assign({ type: 'value' }, AX),
                series: series.map(s => Object.assign({ type: 'bar', stack: 't', barMaxWidth: (bw || 24) }, s))
            };
        },
        optGaugeStage(val, label, color) {
            return {
                series: [{
                    type: 'gauge', startAngle: 210, endAngle: -30, min: 0, max: 100, splitNumber: 5,
                    center: ['50%', '54%'], radius: '96%',
                    axisLine: { lineStyle: { width: 2, color: [[1, 'rgba(68,180,220,.22)']] } },
                    progress: { show: true, width: 5, itemStyle: { color: color } },
                    splitLine: { length: 10, distance: 8, lineStyle: { color: '#4db8d8', width: 1.2 } },
                    axisTick: { splitNumber: 5, length: 4, distance: 8, lineStyle: { color: '#357ea0', width: 1 } },
                    axisLabel: { distance: 13, color: '#57c2e8', fontSize: 9.5 },
                    pointer: { length: '58%', width: 3, itemStyle: { color: color } },
                    anchor: { show: true, size: 9, showAbove: true, itemStyle: { color: color } },
                    detail: { offsetCenter: [0, '62%'], color: '#57c2e8', fontSize: 24, fontWeight: 700, formatter: '{value}' },
                    title: { offsetCenter: [0, '96%'], color: '#cfe8ff', fontSize: 13, fontWeight: 700 },
                    data: [{ value: val, name: label }]
                }]
            };
        },

        /* ---------------- 学段×学科 分段条 ---------------- */
        renderStageSubject(wrapId, segId, data) {
            if (!data || !data.subjects) return;
            /* 学段按钮按后端 subjects 的 key 顺序生成（all 恒在最前），只保留有数据的学段 */
            const keys = Object.keys(data.subjects);
            const stages = (keys.indexOf('all') > -1 ? ['all'] : [])
                .concat(keys.filter(k => k !== 'all' && (data.subjects[k] || []).reduce((a, b) => a + b[1], 0) > 0));
            const segHost = segId ? document.getElementById(segId) : null;
            if (segHost) {
                segHost.innerHTML = stages.map(s => '<span class="ss-btn" data-s="' + s + '">' + ((data.labels && data.labels[s]) || s) + '</span>').join('');
            }
            const me = this;
            const render = (cur) => {
                const wrap = document.getElementById(wrapId);
                if (!wrap) return;
                const items = data.subjects[cur] || [];
                const total = items.reduce((a, b) => a + b[1], 0);
                wrap.innerHTML = '<div class="ss-sub">' + ((data.labels && data.labels[cur]) || '') + ' · 合计 ' + total + ' ' + (data.unit || '人') + '</div><div class="ss-chart" id="' + wrapId + '_bar"></div>';
                me.mk(wrapId + '_bar', {
                    grid: { left: 4, right: 10, top: 26, bottom: 4, containLabel: true },
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 }, formatter: '{b}<br/>{c} ' + (data.unit || '人') },
                    xAxis: { type: 'category', data: items.map(x => x[0]), axisLabel: { color: '#cfe0ff', fontSize: 10, interval: 0, rotate: 42 }, axisLine: { lineStyle: { color: 'rgba(120,170,255,.35)' } }, axisTick: { show: false } },
                    yAxis: { type: 'value', name: data.unit || '人', nameTextStyle: { color: '#9DBBE8', fontSize: 10 }, axisLabel: { color: '#9DBBE8', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(94,150,255,.16)', type: 'dashed' } } },
                    series: [{
                        type: 'bar', data: items.map(x => x[1]), barMaxWidth: 12, barCategoryGap: '32%', showBackground: true,
                        backgroundStyle: { color: 'rgba(80,135,236,.10)', borderRadius: [3, 3, 0, 0] },
                        itemStyle: { borderRadius: [3, 3, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#6FE3FF' }, { offset: 1, color: '#2A63D8' }]) }
                    }]
                });
                if (segHost) segHost.querySelectorAll('.ss-btn').forEach(x => x.classList.toggle('on', x.getAttribute('data-s') === cur));
            };
            if (segHost) {
                segHost.querySelectorAll('.ss-btn').forEach(b => { b.onclick = () => render(b.getAttribute('data-s')); });
            }
            render('all');
        },
        changeAgeView(k) { this.ageView = k; this.drawAgeGender(); },
        changeEvaStage(which, k) {
            if (which === 'e5') { this.e5Stage = k; this.drawEvaAge(); }
            else { this.e6Stage = k; this.drawEvaTeachAge(); }
        },

        /* ---------------- 总览 ---------------- */
        drawOverview() {
            if (!this.ov || !this.ov.teacher) return;
            this.renderStageSubject('o1w', 'o1seg', this.ov.teacher.stageSubject);
            this.drawAgeGender();
            const t = this.ov.teacher;
            if (t.gender) this.mk('t3', this.optDonut(t.gender.labels.map((l, i) => ({ name: l, value: t.gender.values[i] })), { colors: ['#5087ec', '#ffbf6b'], radius: ['40%', '55%'], center: ['50%', '50%'], hideLegend: true }));
            if (t.rank) this.mk('t4', this.optDonut(t.rank.labels.map((l, i) => ({ name: l, value: t.rank.values[i] })), { colors: ['#ed6616', '#5087ec', '#ffbf6b', '#68bbc4'], radius: ['40%', '55%'], center: ['50%', '50%'], hideLegend: true }));
            if (t.edu) this.mk('t5', this.optDonut(t.edu.labels.map((l, i) => ({ name: l, value: t.edu.values[i] })), { colors: ['#68bbc4', '#5087ec', '#ffbf6b', '#3ba272'], radius: ['40%', '55%'], center: ['50%', '50%'], hideLegend: true }));
            if (this.ov.integrate) this.mk('o4', this.optDonut(this.ov.integrate.labels.map((l, i) => ({ name: l, value: this.ov.integrate.values[i] })), { colors: ['#5087ec', '#ffbf6b', '#3ba272'], radius: '54%', center: ['50%', '50%'], solid: true, hideLegend: true }));
            if (this.ov.monthly) this.mk('o2', this.optLine(this.ov.monthly.months, this.ov.monthly.series));
            if (this.ov.schoolTop) this.mk('o3', this.optBarH(this.ov.schoolTop.labels, this.ov.schoolTop.values, '#5087ec', 11));
            if (this.ov.balance) this.drawBalance('o6b');
            if (t.fillBySchool) this.mk('t7', this.optStack(t.fillBySchool.labels, [{ name: '已建画像', data: t.fillBySchool.built }, { name: '待建画像', data: t.fillBySchool.unbuilt }], 13));
            this.drawOvMap();
        },
        drawAgeGender() {
            const a = this.ov.teacher && this.ov.teacher.ageGender;
            if (!a) return;
            if (this.ageView === 'all') {
                this.mk('t2', {
                    grid: { left: 8, right: 14, top: 30, bottom: 4, containLabel: true },
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                    legend: { top: 0, itemWidth: 12, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                    xAxis: Object.assign({ type: 'category', data: a.labels, axisLabel: { color: '#e6efff', fontSize: 11, interval: 0 } }, AX),
                    yAxis: Object.assign({ type: 'value', splitNumber: 3 }, AX),
                    series: [
                        { name: '男', type: 'bar', data: a.male, barMaxWidth: 12, barGap: '40%', barCategoryGap: '46%', itemStyle: { borderRadius: [4, 4, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#6FB6FF' }, { offset: 1, color: '#2A5FD6' }]) }, label: { show: true, position: 'top', color: '#cfe4ff', fontSize: 10 } },
                        { name: '女', type: 'bar', data: a.female, barMaxWidth: 12, barGap: '40%', itemStyle: { borderRadius: [4, 4, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#FFD08A' }, { offset: 1, color: '#F08A2E' }]) }, label: { show: true, position: 'top', color: '#ffe6c2', fontSize: 10 } }
                    ]
                });
            } else {
                const isM = this.ageView === 'male';
                this.mk('t2', {
                    grid: { left: 8, right: 14, top: 14, bottom: 4, containLabel: true },
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                    xAxis: Object.assign({ type: 'category', data: a.labels, axisLabel: { color: '#e6efff', fontSize: 11, interval: 0, rotate: 18 } }, AX),
                    yAxis: Object.assign({ type: 'value', splitNumber: 3 }, AX),
                    series: [{ name: isM ? '男' : '女', type: 'bar', barMaxWidth: 16, data: (isM ? a.male : a.female), itemStyle: { borderRadius: [5, 5, 0, 0], color: isM ? '#4E9BFF' : '#F0A247' }, label: { show: true, position: 'top', color: '#dff1ff', fontSize: 10 } }]
                });
            }
        },
        drawBalance(id) {
            const b = this.ov.balance;
            this.mk(id, {
                grid: { left: 4, right: 10, top: 16, bottom: 2, containLabel: true },
                tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 }, formatter: '{b}<br/>均衡度 {c}' },
                xAxis: { type: 'category', data: b.labels, axisLabel: { color: '#cfe0ff', fontSize: 10, interval: 0, rotate: 42 }, axisLine: { lineStyle: { color: 'rgba(120,170,255,.35)' } }, axisTick: { show: false } },
                yAxis: { type: 'value', max: 100, axisLabel: { color: '#9DBBE8', fontSize: 10 }, splitLine: { lineStyle: { color: 'rgba(94,150,255,.16)', type: 'dashed' } } },
                series: [{
                    type: 'bar', data: b.values, barMaxWidth: 9, barCategoryGap: '35%', showBackground: true,
                    backgroundStyle: { color: 'rgba(80,135,236,.10)', borderRadius: [3, 3, 0, 0] },
                    label: { show: true, position: 'top', color: '#BFE0FF', fontSize: 9 },
                    itemStyle: { borderRadius: [3, 3, 0, 0], color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{ offset: 0, color: '#4DE3FF' }, { offset: 1, color: '#2F66E0' }]) }
                }]
            });
        },
        drawOvMap() {
            try { echarts.registerMap('datong', datongGeo); } catch (e) {}
            this.mk('ovMap', {
                tooltip: { trigger: 'item', backgroundColor: 'rgba(6,24,64,.94)', borderColor: '#4da3ff', textStyle: { color: '#fff', fontSize: 12 }, formatter: (p) => '<b>' + (p.name || '') + '</b>' },
                geo: {
                    map: 'datong', roam: false, zoom: 1.04, aspectScale: .9,
                    label: { show: true, color: '#8fc1ff', fontSize: 9 },
                    itemStyle: { areaColor: 'rgba(28,88,208,.30)', borderColor: '#57b0ff', borderWidth: 1.2, shadowColor: 'rgba(40,140,255,.5)', shadowBlur: 20 },
                    emphasis: { label: { color: '#fff', fontWeight: 'bold' }, itemStyle: { areaColor: 'rgba(64,150,255,.55)' } },
                    regions: [{ name: '浑源县', itemStyle: { areaColor: 'rgba(94,214,255,.40)', borderColor: '#7ee6ff', borderWidth: 2, shadowColor: 'rgba(94,226,255,.85)', shadowBlur: 26 }, label: { show: true, color: '#eafcff', fontWeight: 'bold', fontSize: 11 } }]
                },
                series: [{
                    name: '教研基地', type: 'effectScatter', coordinateSystem: 'geo',
                    data: [{ name: '恒岳教研 · 浑源县', value: [113.699, 39.699] }],
                    rippleEffect: { brushType: 'stroke', scale: 4 }, symbolSize: 7,
                    itemStyle: { color: '#5ee6ff', shadowColor: '#5ee6ff', shadowBlur: 10 },
                    label: { show: true, formatter: '{b}', position: 'right', distance: 6, color: '#eafcff', fontSize: 11, fontWeight: 'bold', textShadowColor: 'rgba(0,30,70,.9)', textShadowBlur: 3 },
                    zlevel: 2
                }]
            });
        },

        /* ---------------- 一体化教研 ---------------- */
        zip(labels, values) {
            if (!labels || !values) return [];
            return labels.map((l, i) => [l, values[i]]);
        },
        drawEva() {
            const e = this.evaData || {};
            if (!e.evaCount && !e.subject) return;
            if (e.type) this.mk('e1', this.optDonut(e.type.labels.map((l, i) => ({ name: l, value: e.type.values[i] })), {}));
            if (e.year) this.mk('e4', this.optLine(e.year.months, e.year.series));
            this.drawEvaAge();
            this.drawEvaTeachAge();
            if (e.subject) this.renderStageSubject('e2w', 'e2seg', { labels: { all: '全部' }, unit: '节', subjects: { all: this.zip(e.subject.labels, e.subject.values) } });
            if (e.num) this.renderStageSubject('e3w', 'e3seg', { labels: { all: '全部' }, unit: '人次', subjects: { all: this.zip(e.num.labels, e.num.values) } });
        },
        drawEvaAge() {
            const a = this.evaData && this.evaData.ageByStage;
            if (!a) return;
            const get = (k) => {
                if (k === 'all') { return a.xx.map((v, i) => v + a.cz[i] + a.gz[i] + (a.qt ? a.qt[i] : 0)); }
                return a[k] || [];
            };
            this.mk('e5', this.optBar(a.labels, get(this.e5Stage), '#3ba272', { rotate: 18 }));
        },
        drawEvaTeachAge() {
            const d = this.evaData && this.evaData.teachAgeByStage;
            if (!d) return;
            const cur = this.e6Stage === 'all' ? d.all : d[this.e6Stage];
            if (!cur) return;
            this.mk('e6', this.optStack(d.items, cur.series));
        },
        evaRing(color, badge) {
            const disc = (cy, rx, ry, w, dash) => {
                return '<ellipse cx="90" cy="' + (cy + 2.6) + '" rx="' + rx + '" ry="' + ry + '" fill="none" stroke="' + color + '" stroke-opacity=".33" stroke-width="' + (w + 1.3) + '"/>'
                    + '<ellipse cx="90" cy="' + cy + '" rx="' + rx + '" ry="' + ry + '" fill="none" stroke="' + color + '" stroke-width="' + w + '"' + (dash ? ' stroke-dasharray="' + dash + '"' : '') + '/>'
                    + '<ellipse cx="90" cy="' + (cy - 0.9) + '" rx="' + (rx - 1) + '" ry="' + (ry - 0.6) + '" fill="none" stroke="#ffffff" stroke-opacity=".5" stroke-width="' + (w * 0.4).toFixed(1) + '"' + (dash ? ' stroke-dasharray="' + dash + '"' : '') + '/>';
            };
            return '<ellipse cx="90" cy="90" rx="73" ry="15" fill="' + color + '" fill-opacity=".08"/>'
                + '<ellipse cx="90" cy="90" rx="70" ry="13" fill="none" stroke="' + color + '" stroke-opacity=".22" stroke-width="3"/>'
                + disc(67, 43, 13, 3) + disc(43, 54, 15, 2.8, '7 6')
                + '<circle cx="90" cy="29" r="14" fill="' + color + '" fill-opacity=".16"/>'
                + '<polygon points="90,20 92.7,26.3 99.5,26.9 94.4,31.4 95.9,38.1 90,34.6 84.1,38.1 85.6,31.4 80.5,26.9 87.3,26.3" fill="' + color + '"/>'
                + '<text x="90" y="32.6" font-size="7.5" font-weight="700" text-anchor="middle" fill="#04122e">' + badge + '</text>';
        },

        /* ---------------- 教科研 ---------------- */
        /* 赛事 / 活动明细表（设计稿 6 列）。注意：带参且模板中带括号调用，必须放 methods，
           放 computed 会被 Vue 解包成字符串导致 `eventRowsHtml is not a function`。 */
        eventRowsHtml(kind) {
            const m = (this.research && this.research[kind]) || {};
            const rows = m.rows || [];
            return this.tableHtml(['名称', '级别', '主办单位', '方向', '报名', '获奖'],
                rows.map(r => [this.ell(r[0]), r[1], r[2], r[3], this.num(r[4]), this.num(r[5])]));
        },
        drawResearch() {
            const r = this.research || {};
            if (this.rsTab === 't1') {
                /* 核心指标 · 教科研概览（中央立体柱 + 四角悬浮卡） */
                const r0 = document.getElementById('r0w');
                if (r0) r0.innerHTML = this.techKpis(this.researchKpiItems, 'a');
                /* 课题来源结构：引领主课题 / 子课题 / 课题申报 占比 */
                if ((r.hostTopic || 0) + (r.leadTopic || 0) + (r.applyTopic || 0) > 0) {
                    this.mk('r1', this.optDonut([
                        { name: '引领主课题', value: r.hostTopic || 0 },
                        { name: '子课题', value: r.leadTopic || 0 },
                        { name: '课题申报', value: r.applyTopic || 0 }
                    ], { solid: true, radius: ['0%', '62%'], formatter: '{b}\n{c} 项' }));
                } else {
                    this.emptyBox('r1', '暂无课题数据');
                }
                if (r.level && r.level.values && r.level.values.length) this.mk('r2', this.optBar(r.level.labels, r.level.values, '#5087ec'));
                else this.emptyBox('r2', '暂无课题数据');
                if (r.classify && r.classify.values && r.classify.values.length) this.mk('r3', this.optBar(r.classify.labels, r.classify.values, '#68bbc4'));
                else this.emptyBox('r3', '暂无课题数据');
                /* 立项 / 成果趋势（按季度，近 8 个季度） */
                if (r.year) this.mk('r5', this.optLine(r.year.months, r.year.series));
            } else {
                this.drawEvent(this.rsTab === 't2' ? 'race' : 'actv');
            }
        },
        /* 赛事 / 活动 Tab：与「课题引领」同款 ISO 六卡（级别 / 学科 / 核心指标 / 趋势 / 奖级 / 明细） */
        drawEvent(kind) {
            const m = (this.research && this.research[kind]) || {};
            const noun = kind === 'race' ? '竞赛' : '活动';
            const kpi = document.getElementById(kind + '0w');
            if (kpi) kpi.innerHTML = this.techKpis(this.researchKpiItems, kind);
            /* 级别分布 */
            const lv = m.level || {};
            if (lv.values && lv.values.length) {
                this.mk(kind + '1', this.optDonut(
                    lv.labels.map((l, i) => ({ name: l, value: lv.values[i] })),
                    { solid: true, radius: ['0%', '62%'], formatter: '{b}\n{c} 场' }));
            } else {
                this.emptyBox(kind + '1', '暂无' + noun + '数据');
            }
            /* 报名学科 TOP（可按学段切换） */
            const ss = m.subjectStage || {};
            if (ss.subjects && (ss.subjects.all || []).length) {
                this.renderStageSubject(kind + '6w', kind + '6seg', ss);
            } else {
                const seg = document.getElementById(kind + '6seg');
                if (seg) seg.innerHTML = '';
                this.emptyBox(kind + '6w', '暂无报名数据');
            }
            /* 年度赛事 / 报名 / 获奖趋势 */
            if (m.year) this.mk(kind + '3', this.optLine(m.year.months, m.year.series));
            /* 获奖奖级分布（仅已定级记录，无则为空状态） */
            const aw = m.award || {};
            if (aw.values && aw.values.some(v => v > 0)) {
                this.mk(kind + '8', this.optDonut(
                    aw.labels.map((l, i) => ({ name: l, value: aw.values[i] })),
                    { solid: true, radius: ['0%', '62%'], formatter: '{b}\n{c} 人次' }));
            } else {
                this.emptyBox(kind + '8', '暂无获奖定级数据');
            }
        },
        /* 核心指标 · 教科研概览：中央立体柱 + 四角悬浮数据卡 + 引线（设计稿同款） */
        techKpis(items, pfx) {
            const uid = pfx || 'a';
            const list = items || [];
            if (!list.length) return '';
            const vmax = Math.max.apply(null, list.map(it => it[1] || 0).concat([1]));
            const pos = ['left:3%;top:5%', 'left:3%;bottom:8%', 'right:3%;top:5%', 'right:3%;bottom:8%'];
            const dia = ['right:-26px;bottom:-20px', 'right:-22px;top:-18px', 'left:-26px;bottom:-20px', 'left:-22px;top:-18px'];
            let cards = '';
            list.forEach((it, i) => {
                cards += '<div class="tk-card" style="' + pos[i] + ';--c:' + it[3] + '">'
                    + '<div class="t"><i></i>' + it[0] + '<em>' + it[1] + '<u>' + it[2] + '</u></em></div>'
                    + '<div class="l">' + it[4] + '</div>'
                    + '</div>'
                    + '<div class="tk-dia" style="' + dia[i] + '"></div>';
            });
            const baseY = 206, maxH = 150, hw = 15, yTop0 = 45, yBot0 = 225;
            const xs = [44, 92, 140, 188];
            /* 按数值从高到低从左往右排 */
            const order = list.map((it, i) => ({ it: it, i: i })).sort((p, q) => (q.it[1] || 0) - (p.it[1] || 0));
            const colX = {};
            order.forEach((o, k) => { colX[o.i] = xs[k]; });
            const colH = (v) => 40 + (maxH - 40) * Math.pow((v || 0) / vmax, 0.7);
            let defs = '', cols = '', lines = '';
            order.forEach((o, k) => {
                const it = o.it, c = it[3], x = xs[k];
                const tY = baseY - colH(it[1]);
                defs += '<linearGradient id="' + uid + 'kc' + k + '" x1="0" y1="0" x2="1" y2="0">'
                    + '<stop offset="0" stop-color="' + c + '" stop-opacity=".10"/>'
                    + '<stop offset=".45" stop-color="' + c + '" stop-opacity=".32"/>'
                    + '<stop offset="1" stop-color="#03102c" stop-opacity=".58"/>'
                    + '</linearGradient>';
                cols += '<path d="M ' + (x - hw) + ' ' + tY + ' L ' + (x - hw) + ' ' + baseY + ' A ' + hw + ' 5 0 0 0 ' + (x + hw) + ' ' + baseY + ' L ' + (x + hw) + ' ' + tY + '" fill="url(#' + uid + 'kc' + k + ')"/>'
                    + '<path d="M ' + (x - hw) + ' ' + tY + ' L ' + (x - hw) + ' ' + baseY + '" stroke="' + c + '" stroke-opacity=".6" stroke-width="1.6" fill="none"/>'
                    + '<path d="M ' + (x + hw) + ' ' + tY + ' L ' + (x + hw) + ' ' + baseY + '" stroke="' + c + '" stroke-opacity=".3" stroke-width="1.2" fill="none"/>'
                    + '<path d="M ' + (x - hw + 4) + ' ' + (tY + 7) + ' L ' + (x - hw + 4) + ' ' + (baseY - 5) + '" stroke="#ffffff" stroke-opacity=".16" stroke-width="3" stroke-linecap="round" fill="none"/>'
                    + '<ellipse cx="' + x + '" cy="' + tY + '" rx="' + hw + '" ry="5" fill="' + c + '" fill-opacity=".22" stroke="' + c + '" stroke-width="2.2"/>'
                    + '<ellipse cx="' + x + '" cy="' + (tY - 7) + '" rx="' + (hw - 5) + '" ry="2.4" fill="' + c + '" fill-opacity=".18"/>'
                    + '<circle cx="' + x + '" cy="' + (tY - 15) + '" r="2" fill="' + c + '" opacity=".75"/>';
            });
            /* 引线：柱子 → 对应卡片（上两卡走柱顶，下两卡走柱底） */
            list.forEach((it, i) => {
                const x = colX[i], c = it[3];
                const isTop = (i === 0 || i === 2);
                const toLeft = (i === 0 || i === 1);
                const ex = toLeft ? 28 : 202;
                const tY = baseY - colH(it[1]);
                const sy = isTop ? (tY - 6) : (baseY - 14);
                const ey = isTop ? yTop0 : yBot0;
                lines += '<path d="M ' + x + ' ' + sy + ' L ' + x + ' ' + ey + ' L ' + ex + ' ' + ey + '" fill="none" stroke="' + c + '" stroke-opacity=".8" stroke-width="1.5" stroke-dasharray="4 4"/>'
                    + '<circle cx="' + x + '" cy="' + sy + '" r="2.2" fill="' + c + '" opacity=".85"/>'
                    + '<circle cx="' + ex + '" cy="' + ey + '" r="2.6" fill="none" stroke="' + c + '" stroke-opacity=".8" stroke-width="1.2"/>';
            });
            const col = '<div class="tk-col"><svg viewBox="0 0 230 240" xmlns="http://www.w3.org/2000/svg">'
                + '<defs><radialGradient id="' + uid + 'kg" cx=".5" cy=".5" r=".5">'
                + '<stop offset="0" stop-color="#64e0ff" stop-opacity=".38"/>'
                + '<stop offset="1" stop-color="#64e0ff" stop-opacity="0"/>'
                + '</radialGradient>' + defs + '</defs>'
                + '<ellipse cx="115" cy="212" rx="100" ry="17" fill="url(#' + uid + 'kg)"/>'
                + lines
                + '<ellipse cx="115" cy="212" rx="78" ry="12" fill="none" stroke="#64e0ff" stroke-opacity=".35" stroke-width="1"/>'
                + '<ellipse cx="115" cy="218" rx="104" ry="12" fill="none" stroke="#64e0ff" stroke-opacity=".28" stroke-width="1" stroke-dasharray="4 5"/>'
                + cols
                + '</svg></div>';
            return '<div class="tech-kpi">' + cards + col + '</div>';
        },

        /* ---------------- 工作室 ---------------- */
        drawMst() {
            const M = this.mst || {};
            if (this.mstTab === 't1') {
                this.renderStageSubject('ms1w', 'ms1seg', { labels: { all: '全部' }, unit: '人', subjects: { all: this.zip(M.member && M.member.labels, M.member && M.member.values) } });
                if (M.backbone) this.mk('ms2', this.optDonut(M.backbone.labels.map((l, i) => ({ name: l, value: M.backbone.values[i] })), { solid: true, colors: ['#3fa2ff', '#ffd04d'], radius: ['0%', '48%'], center: ['50%', '42%'], hideLegend: true }));
                if (M.trend) this.mk('ms3', this.optLine(M.trend.months, [{ name: '成员累计', data: M.trend.series }], ['#55b1ff']));
                if (M.tier) this.mk('ms10', this.optDonut(M.tier.labels.map((l, i) => ({ name: l, value: M.tier.values[i] })), { colors: ['#55b1ff', '#46d08a', '#ffd04d'], radius: ['36%', '58%'], center: ['50%', '44%'] }));
                if (M.activityByStudio) this.mk('ms8', this.optBarH(M.activityByStudio.labels, M.activityByStudio.values, '#55b1ff'));
            } else {
                this.renderStageSubject('ms5w', 'ms5seg', { labels: { all: '全部' }, unit: '项', subjects: { all: this.zip(M.achieveSubject && M.achieveSubject.labels, M.achieveSubject && M.achieveSubject.values) } });
                if (M.achieveType) this.mk('ms4', this.optDonut(M.achieveType.labels.map((l, i) => ({ name: l, value: M.achieveType.values[i] })), { colors: ['#55b1ff', '#ffd04d', '#8f7cf5', '#5ad1e6', '#3fa2ff'], radius: ['30%', '48%'], center: ['50%', '44%'] }));
                if (M.achieveTrend) this.mk('ms6', this.optLine(M.achieveTrend.months, M.achieveTrend.series, ['#55b1ff', '#ffd04d', '#8f7cf5', '#5ad1e6', '#3fa2ff']));
                if (M.top) this.mk('ms7', this.optBarH(M.top.labels, M.top.values, '#55b1ff'));
            }
        },
        drawPr() {
            const M = this.pr || {};
            if (this.prTab === 't1') {
                this.renderStageSubject('pr1w', 'pr1seg', { labels: { all: '全部' }, unit: '人', subjects: { all: this.zip(M.member && M.member.labels, M.member && M.member.values) } });
                if (M.backbone) this.mk('pr2', this.optDonut(M.backbone.labels.map((l, i) => ({ name: l, value: M.backbone.values[i] })), { solid: true, colors: ['#3fa2ff', '#ffd04d'], radius: ['0%', '48%'], center: ['50%', '42%'], hideLegend: true }));
                if (M.trend) this.mk('pr3', this.optLine(M.trend.months, [{ name: '成员累计', data: M.trend.series }], ['#55b1ff']));
                if (M.tier) this.mk('pr10', this.optDonut(M.tier.labels.map((l, i) => ({ name: l, value: M.tier.values[i] })), { colors: ['#55b1ff', '#46d08a', '#ffd04d'], radius: ['36%', '58%'], center: ['50%', '44%'] }));
                if (M.activityByStudio) this.mk('pr8', this.optBarH(M.activityByStudio.labels, M.activityByStudio.values, '#55b1ff'));
            } else {
                this.renderStageSubject('pr5w', 'pr5seg', { labels: { all: '全部' }, unit: '项', subjects: { all: this.zip(M.achieveSubject && M.achieveSubject.labels, M.achieveSubject && M.achieveSubject.values) } });
                if (M.achieveType) this.mk('pr4', this.optDonut(M.achieveType.labels.map((l, i) => ({ name: l, value: M.achieveType.values[i] })), { colors: ['#55b1ff', '#ffd04d', '#8f7cf5', '#5ad1e6', '#3fa2ff'], radius: ['30%', '48%'], center: ['50%', '44%'] }));
                if (M.achieveTrend) this.mk('pr6', this.optLine(M.achieveTrend.months, M.achieveTrend.series, ['#55b1ff', '#ffd04d', '#8f7cf5', '#5ad1e6', '#3fa2ff']));
                if (M.top) this.mk('pr7', this.optBarH(M.top.labels, M.top.values, '#55b1ff'));
            }
        },
        studioRowsHtml(M) {
            const rows = (M && M.rows) || [];
            return this.tableHtml(['工作室', '学科/方向', '成员', '成果', '辐射校'], rows.map(r => [this.ell(r[0]), r[1], r[2], r[3], r[4]]));
        },

        /* ---------------- 资源 ---------------- */
        /* 口径：资源中心主体为「名师优课」课程（courseType=KCK_YK，按 stageType 二级类目细分）；
           题库维度为菁优网组卷数量（jyeoo_paper）；幼教资源为 yg_humanity_video。
           查看量 / 点赞量 / 收藏量均取自课程表 viewCount / likeCount / collectCount。 */
        drawResource() {
            const r = this.res || {};
            if (r.courseTotal == null && r.paperTotal == null) return;
            /* 名师优课 · 月度上架量与查看量 */
            if (r.monthly) this.mk('s2', this.optLine(r.monthly.months, r.monthly.series, ['#55e0ff', '#ffbf6b']));
            /* 各类型课程 查看量 / 点赞量 */
            if (r.cate) {
                this.mk('s3', {
                    color: ['#5087ec', '#ffbf6b'],
                    grid: { left: 8, right: 20, top: 30, bottom: 4, containLabel: true },
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                    legend: { top: 0, itemWidth: 12, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                    xAxis: Object.assign({ type: 'category', data: r.cate.labels, axisLabel: { color: '#e6efff', fontSize: 10.5, interval: 0, rotate: 18 } }, AX),
                    yAxis: Object.assign({ type: 'value' }, AX),
                    series: [
                        { name: '查看量', type: 'bar', data: r.cate.view, barMaxWidth: 16, itemStyle: { borderRadius: [4, 4, 0, 0], color: '#5087ec' }, label: { show: true, position: 'top', color: '#dbe9ff', fontSize: 10 } },
                        { name: '点赞量', type: 'bar', data: r.cate.like, barMaxWidth: 16, itemStyle: { borderRadius: [4, 4, 0, 0], color: '#ffbf6b' }, label: { show: true, position: 'top', color: '#ffe6c2', fontSize: 10 } }
                    ]
                });
            }
            /* 热门课程 TOP 10：按「查看量 + 点赞量 + 收藏量」合计热度降序选取，堆叠展示三项构成 */
            if (r.hot) {
                const hotChart = this.mk('s4', {
                    color: ['#5087ec', '#ffbf6b', '#68bbc4'],
                    grid: { left: 8, right: 52, top: 30, bottom: 4, containLabel: true },
                    tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, confine: true, backgroundColor: 'rgba(10,35,80,.92)', borderColor: '#68bbc4', textStyle: { color: '#fff', fontSize: 12 } },
                    legend: { top: 0, itemWidth: 12, itemHeight: 8, textStyle: { color: '#e6efff', fontSize: 11 }, icon: 'roundRect' },
                    xAxis: Object.assign({}, AX, { type: 'value' }),
                    yAxis: Object.assign({}, AX, {
                        type: 'category', data: r.hot.labels, inverse: true,
                        /* Y 轴课程名最多显示 6 字（超出中间省略号）；data 保留全称 → tooltip 与轴标签 hover 显示全称 */
                        axisLabel: Object.assign({}, AX.axisLabel, {
                            triggerEvent: true,
                            formatter: v => this.midEllipsis(v, 6)
                        })
                    }),
                    series: [
                        { name: '查看量', type: 'bar', stack: 'hot', data: r.hot.view, barMaxWidth: 15, itemStyle: { color: '#5087ec' } },
                        { name: '点赞量', type: 'bar', stack: 'hot', data: r.hot.like, barMaxWidth: 15, itemStyle: { color: '#ffbf6b' } },
                        {
                            name: '收藏量', type: 'bar', stack: 'hot', data: r.hot.collect, barMaxWidth: 15,
                            itemStyle: { color: '#68bbc4', borderRadius: [0, 4, 4, 0] },
                            label: {
                                show: true, position: 'right', color: '#dbe9ff', fontSize: 10,
                                formatter: (p) => (r.hot.total && r.hot.total[p.dataIndex] != null) ? r.hot.total[p.dataIndex] : ''
                            }
                        }
                    ]
                });
                /* 轴标签 hover 时用原生 title 显示课程全称 */
                this.bindAxisTitle(hotChart, r.hot.labels);
            }
            /* 组卷月度趋势 */
            if (r.paperMonthly) this.mk('s6w', this.optBar(r.paperMonthly.months, r.paperMonthly.values, '#8f7cf5', { fmt: '{c}' }));
        },
        dishRing(color, num, unit, label, i) {
            const pfx = 'res' + i;
            return '<div class="res-dish"><svg viewBox="0 0 180 142">'
                + '<defs><linearGradient id="' + pfx + 'gd" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="' + color + '" stop-opacity=".08"/><stop offset="1" stop-color="' + color + '" stop-opacity=".55"/></linearGradient></defs>'
                + '<polygon points="30,28 150,28 114,101 66,101" fill="url(#' + pfx + 'gd)"/>'
                + '<ellipse cx="90" cy="112" rx="78" ry="17" fill="none" stroke="#ffffff" stroke-width="2.6"/>'
                + '<ellipse cx="90" cy="112" rx="63" ry="13.5" fill="none" stroke="#ffffff" stroke-opacity=".75" stroke-width="1.6"/>'
                + '<ellipse cx="90" cy="104" rx="48" ry="10" fill="' + color + '" fill-opacity=".35" stroke="' + color + '" stroke-width="3" stroke-dasharray="7 5"/>'
                + '<text x="90" y="20" text-anchor="middle" font-size="21" font-weight="800" fill="#ffffff" letter-spacing=".5">' + num + '<tspan font-size="10" font-weight="400" fill="#9fd0f5" dx="3">' + unit + '</tspan></text>'
                + '</svg><div class="res-lab" style="color:' + color + '">' + label + '</div></div>';
        },

        /* ---------------- 培训 ---------------- */
        drawTrain() {
            const t = this.trainData || {};
            if (!t.themeViews && !t.courseTotal) return;
            /* 各培训主题看课人次：按课程类型 stageType（名称来自 train_classify 字典）汇总 viewCount */
            const tv = t.themeViews || {};
            if (tv.values && tv.values.some(v => v > 0)) {
                this.mk('tr1', this.optBarH(tv.labels, tv.values, '#8f7cf5'));
            } else {
                this.emptyBox('tr1', '暂无看课人次数据');
            }
            const pg = t.progress || {};
            if (pg.values && pg.values.some(v => v > 0)) this.mk('tr2', this.optDonut(pg.labels.map((l, i) => ({ name: l, value: pg.values[i] })), {}));
            else this.emptyBox('tr2', '暂无学习进度数据');
            const cp = t.courseProgress || {};
            if (cp.labels && cp.labels.length) this.mk('tr3', this.optStack(cp.labels, [{ name: '已看完', data: cp.done }, { name: '看部分', data: cp.partial }]));
            else this.emptyBox('tr3', '暂无完课数据');
            const hot = t.hot || {};
            if (hot.values && hot.values.some(v => v > 0)) {
                /* Y 轴课程名最多显示 6 字（超出中间省略号），tooltip / 轴标签 hover 显示全称 */
                const c4 = this.mk('tr4', this.optBarH(hot.labels, hot.values, '#8f7cf5', undefined, { labelMax: 6 }));
                this.bindAxisTitle(c4, hot.labels);
            } else { this.emptyBox('tr4', '暂无点击数据'); }
        },
        networkKpis(pfx, items) {
            const cx = 350, cy = 310, RB = 240, r = 60, NR = 106;
            let seed = 20261004;
            const rnd = () => { seed = (seed * 1664525 + 1013904223) >>> 0; return seed / 4294967296; };
            const pts = [];
            for (let i = 0; i < 22; i++) {
                const a = rnd() * 6.2832, rr = Math.sqrt(rnd()) * (NR - 10);
                pts.push([cx + Math.cos(a) * rr, cy + Math.sin(a) * rr]);
            }
            let net = '';
            for (let i = 0; i < pts.length; i++) {
                const p1 = pts[i], p2 = pts[(i + 1) % pts.length], p3 = pts[(i + 4) % pts.length];
                net += '<line x1="' + p1[0].toFixed(1) + '" y1="' + p1[1].toFixed(1) + '" x2="' + p2[0].toFixed(1) + '" y2="' + p2[1].toFixed(1) + '" stroke="#35d6c6" stroke-opacity=".55" stroke-width="1.2"/>';
                net += '<line x1="' + p1[0].toFixed(1) + '" y1="' + p1[1].toFixed(1) + '" x2="' + p3[0].toFixed(1) + '" y2="' + p3[1].toFixed(1) + '" stroke="#35d6c6" stroke-opacity=".35" stroke-width=".9"/>';
            }
            for (let i = 0; i < pts.length; i++) {
                net += '<circle cx="' + pts[i][0].toFixed(1) + '" cy="' + pts[i][1].toFixed(1) + '" r="' + (rnd() * 2.4 + 1.4).toFixed(1) + '" fill="#4fe3d4" fill-opacity="' + (rnd() * .5 + .45).toFixed(2) + '"/>';
            }
            let nodes = '';
            const n = items.length;
            for (let i = 0; i < n; i++) {
                const ang = (-90 + 360 / n * i + 360 / n / 2) * Math.PI / 180;
                const bx = cx + Math.cos(ang) * RB, by = cy + Math.sin(ang) * RB;
                const it = items[i];
                nodes += '<line x1="' + (cx + Math.cos(ang) * (NR + 10)).toFixed(1) + '" y1="' + (cy + Math.sin(ang) * (NR + 10)).toFixed(1) + '" x2="' + (bx - Math.cos(ang) * (r + 5)).toFixed(1) + '" y2="' + (by - Math.sin(ang) * (r + 5)).toFixed(1) + '" stroke="#2ba9a9" stroke-width="2.4" stroke-dasharray="2 7" stroke-linecap="round"/>'
                    + '<circle cx="' + bx.toFixed(1) + '" cy="' + by.toFixed(1) + '" r="' + r + '" fill="rgba(8,38,48,.92)" stroke="#2ec5c5" stroke-width="2.8"/>'
                    + '<text x="' + bx.toFixed(1) + '" y="' + (by - 6).toFixed(1) + '" text-anchor="middle" font-size="22" font-weight="800" fill="#ffffff">' + it[0] + '<tspan font-size="12" font-weight="400" fill="#7fd8d4" dx="2">' + it[1] + '</tspan></text>'
                    + '<text x="' + bx.toFixed(1) + '" y="' + (by + 20).toFixed(1) + '" text-anchor="middle" font-size="11" fill="#8fb8c8">' + it[2] + '</text>';
            }
            return '<svg viewBox="0 0 700 620" preserveAspectRatio="xMidYMid meet" style="width:100%;height:100%">'
                + '<defs><radialGradient id="' + pfx + 'netg"><stop offset="0" stop-color="#0e4a52" stop-opacity=".95"/><stop offset=".7" stop-color="#0a323c" stop-opacity=".85"/><stop offset="1" stop-color="#061e26" stop-opacity=".9"/></radialGradient></defs>'
                + '<circle cx="350" cy="310" r="302" stroke="#1d5a6e" stroke-width="6" fill="none"/>'
                + '<circle cx="350" cy="310" r="' + NR + '" fill="url(#' + pfx + 'netg)" stroke="#2ec5c5" stroke-width="1.6" stroke-opacity=".7"/>'
                + net + nodes + '</svg>';
        },

        /* ---------------- 通用 SVG / HTML ---------------- */
        waterKpis(M, pfx) {
            M = M || {};
            const items = [
                ['工作室数', M.count || 0, '个', '#55e0ff'],
                ['成员总数', M.memberTotal || 0, '人', '#ffd04d'],
                ['成果总数', M.achievementTotal || 0, '项', '#ff6b9d'],
                ['辐射学校', M.radiationSchools || 0, '所', '#8f7cf5']
            ];
            const vmax = Math.max(items[0][1], items[1][1], items[2][1], items[3][1], 1);
            const yTop = 36, baseY = 128, rx = 27, ry = 7;
            const bar = (idx, name, val, unit, color) => {
                const uid = pfx + 'wc' + idx;
                const lv = 0.26 + 0.62 * Math.sqrt(val / vmax);
                const lvY = baseY - (baseY - yTop - 4) * lv;
                const x0 = 50 - rx - 6, wd = (rx + 6) * 2;
                const wave = (amp, op, dy) => {
                    const top = lvY - dy;
                    let d = 'M ' + x0.toFixed(1) + ' ' + top.toFixed(1);
                    const nseg = 4, seg = wd / nseg;
                    for (let i = 0; i < nseg; i++) {
                        const sgn = (i % 2 === 0) ? 1 : -1;
                        const x1 = (x0 + seg * (i + 0.5)).toFixed(1), x2 = (x0 + seg * (i + 1)).toFixed(1);
                        d += ' Q ' + x1 + ' ' + (top + sgn * amp).toFixed(1) + ' ' + x2 + ' ' + top.toFixed(1);
                    }
                    d += ' L ' + (50 + rx + 8) + ' ' + (baseY + ry + 3) + ' L ' + (50 - rx - 8) + ' ' + (baseY + ry + 3) + ' Z';
                    return '<path d="' + d + '" fill="' + color + '" opacity="' + op + '"/>';
                };
                return '<div class="wv-ball"><svg viewBox="0 0 100 162" preserveAspectRatio="xMidYMid meet">'
                    + '<defs><clipPath id="' + uid + '"><rect x="' + (50 - rx) + '" y="' + yTop + '" width="' + (rx * 2) + '" height="' + (baseY - yTop) + '"/><ellipse cx="50" cy="' + baseY + '" rx="' + rx + '" ry="' + ry + '"/></clipPath>'
                    + '<linearGradient id="' + uid + 'g" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="' + color + '" stop-opacity=".30"/><stop offset=".38" stop-color="' + color + '" stop-opacity=".12"/><stop offset="1" stop-color="#03102c" stop-opacity=".62"/></linearGradient></defs>'
                    + '<rect x="' + (50 - rx) + '" y="' + yTop + '" width="' + (rx * 2) + '" height="' + (baseY - yTop) + '" fill="url(#' + uid + 'g)"/>'
                    + '<ellipse cx="50" cy="' + baseY + '" rx="' + rx + '" ry="' + ry + '" fill="url(#' + uid + 'g)"/>'
                    + '<g clip-path="url(#' + uid + ')">' + wave(4, .24, 1.6) + wave(6.5, .52, 0) + '</g>'
                    + '<path d="M ' + (50 - rx) + ' ' + yTop + ' L ' + (50 - rx) + ' ' + baseY + '" fill="none" stroke="' + color + '" stroke-opacity=".55" stroke-width="1.6"/>'
                    + '<path d="M ' + (50 + rx) + ' ' + yTop + ' L ' + (50 + rx) + ' ' + baseY + '" fill="none" stroke="' + color + '" stroke-opacity=".32" stroke-width="1.6"/>'
                    + '<ellipse cx="50" cy="' + yTop + '" rx="' + rx + '" ry="' + ry + '" fill="' + color + '" fill-opacity=".2" stroke="' + color + '" stroke-opacity=".85" stroke-width="1.8"/>'
                    + '<text x="50" y="106" text-anchor="middle" font-weight="700" font-size="16" fill="#ffffff">' + val + '<tspan font-size="8.5" fill="#cfe4ff" dx="2">' + unit + '</tspan></text>'
                    + '<text x="50" y="157" text-anchor="middle" font-size="10.5" fill="#cfe0ff" letter-spacing=".5">' + name + '</text>'
                    + '</svg></div>';
            };
            return '<div class="wv-row">' + items.map((it, i) => bar(i, it[0], it[1], it[2], it[3])).join('') + '</div>';
        },
        tableHtml(head, rows) {
            let h = '<div style="padding:0 4px 4px"><table class="tb"><thead><tr>' + head.map(x => '<th>' + x + '</th>').join('') + '</tr></thead><tbody>';
            h += rows.map(r => '<tr>' + r.map(c => '<td>' + c + '</td>').join('') + '</tr>').join('');
            h += '</tbody></table></div>';
            return h;
        },
        /** 大数值压缩：>=1万 显示为 x.x万，避免碟环数字溢出 */
        fmtNum(v) {
            const n = (v == null || isNaN(v)) ? 0 : Number(v);
            if (n >= 10000) return (Math.round(n / 1000) / 10) + '万';
            return String(n);
        },
        ell(t) { return '<div class="ell">' + (t == null ? '' : t) + '</div>'; },
        num(t) { return '<span class="num">' + (t == null ? 0 : t) + '</span>'; },
        badge(t) {
            const cls = t === '预警' ? 'warn' : (t === '关注' ? 'wait' : (t === '在研' || t === '进行中' ? 'run' : 'ok'));
            return '<span class="badge ' + cls + '">' + t + '</span>';
        }
    }
};
</script>

<style>
/* ============================================================
   教研驾驶舱 · 区域教科研数据中枢（深蓝科技大屏）
   本页为独立全屏路由 /areaDashboard，统一以 .cockpit-root 作为命名空间前缀，
   避免与 statDashboard / schoolDashboard 等看板的同名类（.stat-container/.card…）互相污染。
   ============================================================ */
.cockpit-root{
  --bg:#1f5bdf; --card:#2076ff; --panel:#1f5bdf; --side:#dfe4f7;
  --accent:#56e6f1; --c1:#68bbc4; --c2:#5087ec; --c3:#ffbf6b; --c4:#3ba272;
  --c5:#ed6616; --c6:#f39423; --c7:#f9c78b; --c8:#8f7cf5;
  /* 固定设计稿尺寸，JS 按窗口比例写入 transform:scale(...) 整页缩放 */
  width:1920px; height:1080px; position:fixed; left:0; top:0;
  transform-origin:0 0; display:flex; overflow:hidden;
  margin:0; padding:0; color:#fff;
  background:linear-gradient(180deg,#04123c,#061a4c);
  font-family:"PingFang SC","SourceHanSansSC","Microsoft YaHei",sans-serif;
}
.cockpit-root .card-hd i,.cockpit-root .card-hd em,.cockpit-root .ds-item i{font-style:normal}

/* ============ 左侧导航 ============ */
.cockpit-root .l-stat-container{
  width:292px; min-width:292px; height:100%; box-sizing:border-box; display:flex; flex-direction:column;
  position:relative; z-index:40;
  background:linear-gradient(180deg,#0a2158,#071b49);
  border-right:1px solid rgba(66,152,255,.22);
  transition:width .26s cubic-bezier(.4,0,.2,1),min-width .26s cubic-bezier(.4,0,.2,1);
}
.cockpit-root .org-container{padding:18px 8px 12px}
.cockpit-root .org-logo{
  width:62px; height:62px; border-radius:31px; margin:0 auto;
  background:linear-gradient(135deg,#1f5bdf,#68bbc4);
  display:flex; align-items:center; justify-content:center;
  font-size:17px; font-weight:700; color:#fff; white-space:nowrap;
  transition:width .26s cubic-bezier(.4,0,.2,1),height .26s cubic-bezier(.4,0,.2,1),border-radius .26s cubic-bezier(.4,0,.2,1);
}
.cockpit-root .school-name{
  width:100%; height:30px; line-height:30px; text-align:center; color:#fff;
  font-size:17px; font-weight:700; margin-top:9px;
  transition:opacity .18s ease,height .26s cubic-bezier(.4,0,.2,1),margin-top .26s cubic-bezier(.4,0,.2,1);
}
.cockpit-root .org-name{width:100%; text-align:center; color:#9db9e8; font-size:13px; font-weight:600}
.cockpit-root .menu-container{flex:1; padding:12px 0 14px; overflow-y:auto; background:transparent}
.cockpit-root .menu-container::-webkit-scrollbar{width:5px}
.cockpit-root .menu-container::-webkit-scrollbar-thumb{background:rgba(255,255,255,.22);border-radius:3px}
.cockpit-root .menu-item{
  height:68px; line-height:68px; font-size:17.5px; color:#9db9e8; cursor:pointer;
  padding:0 16px; display:flex; align-items:center; justify-content:space-between;
  transition:.18s; border-left:3px solid transparent;
}
.cockpit-root .menu-item:hover{color:#fff; background:rgba(70,140,255,.16)}
.cockpit-root .menu-active{
  background:linear-gradient(90deg,rgba(64,150,255,.55),rgba(28,86,214,.22));
  color:#fff; font-weight:700; border-left-color:var(--accent);
}
.cockpit-root .menu-active:hover{color:#fff}
.cockpit-root .mi-ico{
  width:20px; height:20px; flex:0 0 20px; margin-right:12px;
  display:flex; align-items:center; justify-content:center; opacity:.95;
  transition:margin-right .26s cubic-bezier(.4,0,.2,1);
}
.cockpit-root .mi-ico svg{width:20px; height:20px; display:block}
.cockpit-root .mi-label{
  flex:1 1 auto; min-width:0; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;
  transition:opacity .16s ease;
}

/* ---- 左侧导航收起态 ---- */
.cockpit-root.side-collapsed .l-stat-container{width:92px; min-width:92px}
.cockpit-root.side-collapsed .org-container{padding:14px 6px 8px}
.cockpit-root.side-collapsed .org-logo{width:48px; height:48px; border-radius:24px; font-size:18px; white-space:normal}
.cockpit-root.side-collapsed .school-name{height:0; opacity:0; margin-top:0; overflow:hidden}
.cockpit-root.side-collapsed .org-name{display:none}
.cockpit-root.side-collapsed .menu-container{padding:8px 0 10px; overflow:visible}
.cockpit-root.side-collapsed .menu-item{
  height:64px; line-height:64px; padding:0; justify-content:center;
  border-left-width:0; position:relative;
}
.cockpit-root.side-collapsed .menu-item .mi-ico{margin-right:0; width:28px; height:28px; flex:0 0 28px}
.cockpit-root.side-collapsed .menu-item .mi-ico svg{width:28px; height:28px}
.cockpit-root.side-collapsed .menu-item .mi-label{flex:0 0 0; width:0; opacity:0}
.cockpit-root.side-collapsed .menu-item::after{
  content:attr(data-label); position:absolute; left:calc(100% + 12px); top:50%;
  transform:translateY(-50%) translateX(-4px); background:#0f2f6e; color:#fff;
  font-size:14px; font-weight:600; line-height:1; padding:9px 13px; border-radius:6px;
  white-space:nowrap; opacity:0; visibility:hidden; pointer-events:none; z-index:99;
  border:1px solid rgba(86,230,241,.45); box-shadow:0 8px 22px rgba(0,0,0,.3);
  transition:opacity .16s ease,transform .16s ease,visibility .16s;
}
.cockpit-root.side-collapsed .menu-item:hover::after{opacity:1; visibility:visible; transform:translateY(-50%) translateX(0)}

/* ============ 右侧主区 ============ */
.cockpit-root .r-stat-container{
  flex:1; min-width:0; height:100%; box-sizing:border-box; display:flex; flex-direction:column;
  padding:0 12px 10px; overflow:hidden;
}
.cockpit-root .topbar{position:relative; height:82px; min-height:82px; display:flex; align-items:center; gap:16px; padding:0 4px}
.cockpit-root .side-toggle{
  width:34px; height:34px; min-width:34px; flex:0 0 34px; border-radius:8px;
  border:1px solid rgba(255,255,255,.3); background:rgba(255,255,255,.12); color:#dbe7ff;
  cursor:pointer; display:flex; align-items:center; justify-content:center; padding:0;
  transition:background .18s,border-color .18s,color .18s;
}
.cockpit-root .side-toggle:hover{background:rgba(86,230,241,.22); border-color:var(--accent); color:#fff}
.cockpit-root .side-toggle svg{display:block; transition:transform .26s cubic-bezier(.4,0,.2,1)}
.cockpit-root.side-collapsed .side-toggle svg{transform:rotate(180deg)}
.cockpit-root .top-title{
  position:absolute; left:50%; top:50%; transform:translate(-50%,-50%); z-index:5;
  font-size:23px; font-weight:700; letter-spacing:5px; color:#eaf5ff; white-space:nowrap;
  padding:9px 60px 10px; text-shadow:0 0 16px rgba(130,205,255,.9);
  background:linear-gradient(90deg,rgba(13,48,128,0) 0%,rgba(20,70,185,.55) 14%,rgba(40,116,255,.92) 50%,rgba(20,70,185,.55) 86%,rgba(13,48,128,0) 100%);
  clip-path:polygon(16px 0,calc(100% - 16px) 0,100% 100%,0 100%);
}
.cockpit-root .top-title::before,.cockpit-root .top-title::after{content:""; position:absolute; bottom:0; width:10px; height:5px; background:#6fd3ff; opacity:.9}
.cockpit-root .top-title::before{left:-14px; clip-path:polygon(0 100%,100% 100%,100% 0)}
.cockpit-root .top-title::after{right:-14px; clip-path:polygon(0 100%,0 0,100% 100%)}
.cockpit-root .top-spacer{flex:1}
.cockpit-root .top-ctl{display:flex; align-items:center; gap:8px; font-size:16px; color:#dbe7ff}

/* 顶部统计组织下拉框（深色顶栏适配） */
.cockpit-root .top-ctl .el-select .el-input__wrapper{
  background:rgba(255,255,255,.14); border:1px solid rgba(255,255,255,.35);
  box-shadow:none; border-radius:4px;
}
.cockpit-root .top-ctl .el-select .el-input__wrapper:hover{border-color:rgba(86,230,241,.75)}
.cockpit-root .top-ctl .el-select .el-input__wrapper.is-focus{border-color:var(--accent); box-shadow:0 0 0 1px rgba(86,230,241,.4)}
.cockpit-root .top-ctl .el-select .el-input__inner{color:#fff}
.cockpit-root .top-ctl .el-select .el-input__inner::placeholder{color:rgba(255,255,255,.65)}
.cockpit-root .top-ctl .el-select .el-select__caret{color:#dbe7ff}

/* 顶栏 Tab（工作室 / 教科研） */
.cockpit-root .mst-tab{
  flex:none; border:1px solid rgba(66,152,255,.45); background:rgba(40,110,255,.10);
  color:#bfd6f8; font-size:14.5px; padding:7px 24px; border-radius:3px; cursor:pointer;
  font-family:inherit; letter-spacing:1.5px; transition:.16s;
}
.cockpit-root .mst-tab:hover{border-color:#55b1ff; color:#eaf4ff}
.cockpit-root .mst-tab.on{
  background:linear-gradient(180deg,#55b1ff,#2f7ef0); color:#04123c;
  border-color:#55b1ff; font-weight:700; box-shadow:0 0 12px rgba(85,177,255,.45);
}

/* ============ 视口 / 面板 ============ */
.cockpit-root .viewport{
  flex:1; min-height:0; overflow:hidden; position:relative;
  background:
    linear-gradient(rgba(84,156,255,.05) 1px,transparent 1px),
    linear-gradient(90deg,rgba(84,156,255,.05) 1px,transparent 1px),
    radial-gradient(1100px 460px at 50% -60px, rgba(28,86,214,.40), transparent 62%),
    radial-gradient(900px 420px at 50% 112%, rgba(8,54,150,.36), transparent 60%),
    linear-gradient(180deg,#051540,#071e56 52%,#04123c);
  background-size:36px 36px,36px 36px,auto,auto,auto;
}
.cockpit-root .panel{
  position:absolute; inset:0; overflow:hidden;
  display:flex; flex-direction:column; background:transparent;
}

/* ============ KPI ============ */
.cockpit-root .kpi-row{display:flex; gap:10px; margin-bottom:10px; flex-wrap:wrap}
.cockpit-root .kpi-item{
  flex:1; min-width:150px; border-radius:6px; padding:12px 8px 10px; text-align:center;
  position:relative; overflow:hidden;
  background:linear-gradient(168deg,rgba(15,50,128,.78),rgba(6,22,62,.92));
  border:1px solid rgba(66,152,255,.30); box-shadow:inset 0 0 18px rgba(36,104,255,.14);
}
.cockpit-root .kpi-item::after{
  content:""; position:absolute; left:0; top:12%; width:4px; height:76%;
  background:#3fa2ff; border-radius:2px; box-shadow:0 0 8px rgba(63,162,255,.9);
}
.cockpit-root .kpi-item.a0::after{background:var(--accent)}
.cockpit-root .kpi-item.a1::after{background:var(--c1)}
.cockpit-root .kpi-item.a2::after{background:var(--c3)}
.cockpit-root .kpi-item.a3::after{background:var(--c4)}
.cockpit-root .kpi-item.a4::after{background:var(--c5)}
.cockpit-root .kpi-item.a5::after{background:var(--c8)}
.cockpit-root .kpi-val{font-size:23px; font-weight:600; line-height:1.15; letter-spacing:.5px; color:#fff; text-shadow:0 0 14px rgba(96,190,255,.9)}
.cockpit-root .kpi-val .u{font-size:12px; font-weight:400; margin-left:3px; color:#cfe0ff}
.cockpit-root .kpi-lab{font-size:12px; color:#b9d5ff; margin-top:5px}
.cockpit-root .kpi-lab .sub{color:#ffbf6b; font-size:11px; margin-left:4px}
.cockpit-root .kpi-sub{font-size:9px; color:#ffbf6b; margin-top:2px; line-height:1.2; white-space:nowrap}

/* ============ 栅格 / 卡片 / 图表 ============ */
.cockpit-root .grid{display:grid; gap:10px; margin-bottom:10px}
.cockpit-root .g2{grid-template-columns:1fr 1fr}
.cockpit-root .g3{grid-template-columns:1fr 1fr 1fr}
.cockpit-root .g21{grid-template-columns:1.35fr 1fr}
.cockpit-root .card{
  border-radius:6px; padding:0 0 8px; overflow:hidden; display:flex; flex-direction:column;
  position:relative;
  background:linear-gradient(168deg,rgba(13,44,116,.66),rgba(5,18,52,.90));
  border:1px solid rgba(66,152,255,.28); box-shadow:inset 0 0 26px rgba(28,96,240,.12);
}
.cockpit-root .card::before,.cockpit-root .card::after{
  content:""; position:absolute; width:9px; height:9px; pointer-events:none;
  border:1.5px solid #55b1ff; opacity:.9;
}
.cockpit-root .card::before{left:0; top:0; border-right:none; border-bottom:none}
.cockpit-root .card::after{right:0; bottom:0; border-left:none; border-top:none}
.cockpit-root .card-hd{height:36px; min-height:36px; display:flex; align-items:center; padding:0 10px; gap:8px}
.cockpit-root .card-hd i{width:4px; height:15px; background:var(--accent); border-radius:2px; flex:none}
.cockpit-root .card-hd span{font-size:12.5px; font-weight:500; letter-spacing:.6px; color:#d9ecff}
.cockpit-root .card-hd .src{margin-left:auto; font-size:10px; font-style:normal; padding:1px 7px; border-radius:8px; display:none}
.cockpit-root .card-hd .hd-seg{margin-left:auto; display:flex; align-items:center; flex:none}
.cockpit-root .chart{height:210px; width:100%}
.cockpit-root .chart.lg{height:250px}

/* ============ 表格 ============ */
.cockpit-root .tb{width:100%; border-collapse:collapse; font-size:12px}
.cockpit-root .tb th{color:#bcd2ff; font-weight:600; text-align:left; padding:7px 10px; border-bottom:1px solid rgba(255,255,255,.18); white-space:nowrap}
.cockpit-root .tb td{padding:7px 10px; border-bottom:1px solid rgba(255,255,255,.09); color:#eaf2ff}
.cockpit-root .tb tr:hover td{background:rgba(255,255,255,.06)}
.cockpit-root .tb div.ell{max-width:150px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap}
.cockpit-root .tb .num{color:#ffbf6b; font-weight:700}
.cockpit-root .badge{font-size:11px; padding:1px 7px; border-radius:8px; background:rgba(255,255,255,.16); display:inline-block}
.cockpit-root .badge.ok{background:rgba(105,240,174,.2); color:#8bf5c0}
.cockpit-root .badge.run{background:rgba(86,230,241,.2); color:#b6f4fa}
.cockpit-root .badge.wait{background:rgba(255,191,107,.2); color:#ffd79a}
.cockpit-root .badge.warn{background:rgba(237,102,22,.25); color:#ffc59a}
.cockpit-root .tbl-wrap,.cockpit-root .tbl-scroll{flex:1 1 auto; min-height:0; overflow:auto; padding-bottom:4px}
.cockpit-root .tbl-wrap::-webkit-scrollbar,.cockpit-root .tbl-scroll::-webkit-scrollbar{height:7px; width:7px}
.cockpit-root .tbl-wrap::-webkit-scrollbar-thumb,.cockpit-root .tbl-scroll::-webkit-scrollbar-thumb{background:rgba(255,255,255,.28); border-radius:4px}

/* ============ 说明 / 小节标题 ============ */
.cockpit-root .note{font-size:11.5px; color:#cfe0ff; padding:2px 10px 8px; line-height:17px}
.cockpit-root .note b{color:#ffbf6b}
.cockpit-root .sec-hd{margin:16px 0 9px; display:flex; align-items:center; gap:9px; font-size:15px; font-weight:700; letter-spacing:1px; color:#fff}
.cockpit-root .sec-hd::before{content:""; width:4px; height:16px; border-radius:2px; background:var(--accent); flex:none}
.cockpit-root .sec-hd .cnt{font-size:11.5px; font-weight:400; color:#cfe0ff; letter-spacing:0}
.cockpit-root .sec-hd::after{content:""; flex:1; height:1px; background:linear-gradient(90deg,rgba(255,255,255,.38),rgba(255,255,255,0))}

/* ============ 学段 × 学科 分段切换 ============ */
.cockpit-root .ss-seg{display:flex; gap:5px; padding:9px 10px 0; flex-wrap:wrap}
.cockpit-root .ss-btn{
  border:1px solid rgba(255,255,255,.32); background:rgba(255,255,255,.08); color:#dbe7ff;
  font-size:11.5px; padding:3px 13px; border-radius:14px; cursor:pointer;
  font-family:inherit; transition:.16s; white-space:nowrap;
}
.cockpit-root .ss-btn:hover{border-color:var(--accent)}
.cockpit-root .ss-btn.on{background:var(--accent); color:#0b3a7a; border-color:var(--accent); font-weight:700}
.cockpit-root .ss-sub{font-size:11.5px; color:#cfe0ff; padding:4px 10px 0}
.cockpit-root .ss-chart{height:210px}
.cockpit-root .ov-wrap .ss-chart{height:182px; padding:2px 4px 0}
.cockpit-root .card-hd .ss-seg{padding:0; gap:4px; flex-wrap:nowrap; justify-content:flex-end}
.cockpit-root .card-hd .ss-btn{padding:1px 8px; font-size:9.5px; line-height:1.3}
.cockpit-root .ov-main .ss-seg{justify-content:flex-end}

/* ============ 面板1：区域教研总览（一屏铺满，高度弹性分配） ============ */
.cockpit-root #panel-overview .ov-wrap{flex:1 1 auto; min-height:0; display:flex; flex-direction:column}
.cockpit-root .ov-wrap{position:relative}
.cockpit-root .ov-main{
  display:grid;
  grid-template-columns:minmax(232px,3.6fr) minmax(0,4.6fr) minmax(232px,3.6fr);
  grid-template-rows:minmax(0,1fr);
  gap:10px; margin-bottom:10px; flex:1.7 1 0; min-height:0;
}
.cockpit-root .ov-col{display:flex; flex-direction:column; gap:10px; min-width:0; min-height:0}
.cockpit-root .ov-col>.card{flex:1; min-height:0}
.cockpit-root .ov-body{
  display:flex; flex-direction:column; align-items:stretch; gap:4px;
  height:calc(100% - 32px); padding:0 4px 5px; min-height:0;
}
.cockpit-root .ov-map{height:calc(100% - 36px); min-height:150px; width:100%}
.cockpit-root .ov-body .ov-map{flex:1 1 auto; min-height:0; width:100%; height:auto}
/* 顶部核心指标横条：一横条不换行，高度受限（超出可纵向滑动） */
.cockpit-root .ov-kpi-strip{flex:0 0 auto; flex-wrap:nowrap; max-height:92px; overflow-x:hidden; overflow-y:auto; margin-bottom:10px}
.cockpit-root .ov-kpi-strip::-webkit-scrollbar{width:5px}
.cockpit-root .ov-kpi-strip::-webkit-scrollbar-thumb{background:rgba(255,255,255,.22); border-radius:3px}
.cockpit-root .ov-kpi-strip .kpi-item{flex:1 1 0; min-width:0; padding:8px 6px 7px}
.cockpit-root .ov-kpi-strip .kpi-val{font-size:19px}
.cockpit-root .ov-kpi-strip .kpi-val .u{font-size:10px}
.cockpit-root .ov-kpi-strip .kpi-lab{font-size:11px; margin-top:3px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap}
.cockpit-root .ov-kpi-strip .kpi-sub{font-size:9px; overflow:hidden; text-overflow:ellipsis}
.cockpit-root .ov-main .chart{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root #o6b{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root .ov-main #o1w{flex:1 1 auto; min-height:0; display:flex; flex-direction:column}
.cockpit-root .ov-main #o1w .ss-sub{flex:none}
.cockpit-root .ov-main .ss-chart{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root .ov-main .note{font-size:10.5px; line-height:16px; padding:2px 8px 6px; flex:none}
.cockpit-root .ov-main .note b{color:#ffd04d}
.cockpit-root .ov-bottom{display:grid; grid-template-columns:repeat(6,1fr); grid-template-rows:minmax(0,1fr); gap:10px; flex:1 1 0; min-height:0}
.cockpit-root .ov-bottom .chart{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root .ov-wrap .card-hd{height:32px; min-height:32px}
.cockpit-root .ov-wrap .card-hd span{font-size:13px}
.cockpit-root .ds-wrap{display:flex; flex-direction:column; align-items:center; justify-content:center; height:auto; flex:1 1 auto; min-height:0; padding:2px 6px 4px; gap:3px}
.cockpit-root .ds-chart{width:100%; height:auto; flex:1 1 auto; min-height:0; min-width:0}
.cockpit-root .ds-legend{flex:none; width:100%; display:flex; flex-wrap:wrap; justify-content:center; align-items:center; gap:5px 20px; min-width:0; padding:0 4px}
.cockpit-root .ds-item{display:flex; align-items:center; gap:8px}
.cockpit-root .ds-item i{flex:0 0 6px; width:6px; height:17px; border-radius:3px}
.cockpit-root .ds-txt{display:flex; align-items:baseline; gap:7px; white-space:nowrap}
.cockpit-root .ds-txt span{font-size:14.5px; color:#d9ecff; white-space:nowrap}
.cockpit-root .ds-txt b{font-size:16.5px; color:#fff; font-weight:700}

/* ============ 面板4：一体化教研驾驶舱 ============ */
.cockpit-root .eva-main{
  display:grid; grid-template-columns:repeat(3,minmax(0,1fr)); grid-template-rows:minmax(0,1fr); gap:10px;
  flex:1.5 1 0; min-height:0; margin-bottom:10px;
}
.cockpit-root #panel-eva > .grid{flex:1 1 0; min-height:0; margin-bottom:0; gap:10px; grid-auto-rows:minmax(0,1fr)}
.cockpit-root .eva-col{display:flex; flex-direction:column; gap:10px; min-width:0; min-height:0}
.cockpit-root .eva-col>.card{flex:1 1 0; min-height:0}
.cockpit-root #panel-eva .card>.chart{flex:1 1 auto; min-height:0; height:auto}
.cockpit-root #panel-eva .card>[id$="w"]{flex:1 1 auto; min-height:0; height:auto; display:flex; flex-direction:column}
.cockpit-root #panel-eva .ss-chart{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root .eva-kpis{
  display:grid; grid-template-columns:repeat(6,1fr); align-content:center; justify-items:center;
  flex:1 1 auto; min-height:0; padding:2px 4px 10px; gap:14px 2px;
}
.cockpit-root .eva-kpi{text-align:center; min-width:0; width:100%; grid-column:span 2}
.cockpit-root .eva-kpi:nth-child(1){grid-column:2/4}
.cockpit-root .eva-kpi:nth-child(2){grid-column:4/6}
.cockpit-root .eva-kpi .num{font-size:28px; font-weight:800; line-height:1.06}
.cockpit-root .eva-kpi .lab{font-size:12px; color:#cfe0f5; margin-top:2px; white-space:nowrap}
.cockpit-root .eva-kpi .sub{display:block; font-size:10.5px; color:#8aa5c8; margin-top:1px; white-space:nowrap}
.cockpit-root .eva-kpi svg{display:block; margin:4px auto 0; width:100%; max-width:104px; height:auto}
.cockpit-root .eva-kpi:nth-child(n+3) .num{font-size:23px}
.cockpit-root .eva-kpi:nth-child(n+3) .lab{font-size:11px}
.cockpit-root .eva-kpi:nth-child(n+3) .sub{font-size:9.5px}

/* ============ 面板2/3/5：工作室 & 教科研（Tab 内容区自适应） ============ */
.cockpit-root #panel-studio-mst > .mst-tabpane,
.cockpit-root #panel-studio-pr > .mst-tabpane,
.cockpit-root #panel-research > .mst-tabpane{
  flex:1 1 auto; min-height:0; overflow:hidden;
  display:flex; flex-direction:column; gap:10px;
}
.cockpit-root #panel-studio-mst .mst-iso-grid,
.cockpit-root #panel-studio-pr .mst-iso-grid{flex:1 1 auto; min-height:0; margin-bottom:0}
/* 教科研与工作室同款 ISO 三栏六卡：一屏满高排布，表格在卡片内部滚动 */
.cockpit-root #panel-research .mst-iso-grid{flex:1 1 auto; min-height:0; margin-bottom:0}

/* ============ ISO 三栏布局（工作室 / 资源 / 培训） ============ */
.cockpit-root .mst-iso-grid{display:grid; grid-template-columns:1fr 1.55fr 1fr; grid-template-rows:minmax(0,1fr) minmax(0,1fr); gap:10px}
.cockpit-root .mst-iso-grid .card{min-height:0}
.cockpit-root .mst-iso-grid .card:nth-child(1){grid-column:1; grid-row:1}
.cockpit-root .mst-iso-grid .card:nth-child(2){grid-column:3; grid-row:1}
.cockpit-root .mst-iso-grid .card:nth-child(3){grid-column:2; grid-row:1}
.cockpit-root .mst-iso-grid .card:nth-child(4){grid-column:1; grid-row:2}
.cockpit-root .mst-iso-grid .card:nth-child(5){grid-column:3; grid-row:2}
.cockpit-root .mst-iso-grid .card:nth-child(6){grid-column:2; grid-row:2}
.cockpit-root .mst-iso-grid .chart,.cockpit-root .mst-iso-grid .chart.lg{height:calc(100% - 36px)}
.cockpit-root .mst-iso-grid #ms0w,.cockpit-root .mst-iso-grid #pr0w,
.cockpit-root .mst-iso-grid #ms1w,.cockpit-root .mst-iso-grid #pr1w,
.cockpit-root .mst-iso-grid #ms5w,.cockpit-root .mst-iso-grid #pr5w,
.cockpit-root .mst-iso-grid #ms9w,.cockpit-root .mst-iso-grid #pr9w{height:calc(100% - 36px); display:flex; flex-direction:column}
.cockpit-root .mst-iso-grid #s0w,
.cockpit-root .mst-iso-grid #tr0w{height:calc(100% - 36px)}
.cockpit-root .mst-iso-grid #r0w,
.cockpit-root .mst-iso-grid #race0w,
.cockpit-root .mst-iso-grid #actv0w{height:calc(100% - 36px)}
.cockpit-root .mst-iso-grid #race6w,
.cockpit-root .mst-iso-grid #actv6w{height:calc(100% - 36px); display:flex; flex-direction:column}
.cockpit-root .mst-iso-grid .ss-chart{height:auto; flex:1 1 auto; min-height:0}
.cockpit-root #panel-resource > .mst-iso-grid,
.cockpit-root #panel-train > .mst-iso-grid{flex:1 1 auto; min-height:0; margin-bottom:0}

/* 图表空状态占位（全 0 / 无数据时不渲染空白块） */
.cockpit-root .empty-tip{
  height:100%; min-height:90px; display:flex; align-items:center; justify-content:center;
  color:#7d97bd; font-size:12.5px; letter-spacing:.6px;
}
.cockpit-root .empty-tip::before{
  content:""; width:6px; height:6px; margin-right:8px; transform:rotate(45deg);
  background:rgba(120,170,255,.55); box-shadow:0 0 8px rgba(86,230,241,.6);
}

/* 中央立体柱 + 四角悬浮数据卡（核心指标 · 教科研概览） */
.cockpit-root .tech-kpi{position:relative; height:100%; min-height:0}
.cockpit-root .tech-kpi .tk-col{
  position:absolute; left:50%; top:50%; transform:translate(-50%,-50%);
  width:58%; height:97%; display:flex; align-items:center; justify-content:center;
}
.cockpit-root .tech-kpi .tk-col svg{width:100%; height:100%; display:block; filter:drop-shadow(0 0 14px rgba(64,214,255,.22))}
.cockpit-root .tk-card{
  position:absolute; width:158px; padding:8px 11px 9px;
  background:linear-gradient(160deg,rgba(9,32,66,.92),rgba(4,18,42,.88));
  border:1px solid rgba(64,214,255,.5);
  clip-path:polygon(12px 0,100% 0,100% calc(100% - 12px),calc(100% - 12px) 100%,0 100%,0 12px);
  box-shadow:inset 0 0 16px rgba(38,150,255,.22),0 2px 14px rgba(2,10,30,.5);
}
.cockpit-root .tk-card .t{display:flex; align-items:center; gap:7px; font-size:12px; font-weight:700; color:#ecf7ff; letter-spacing:.5px; white-space:nowrap}
.cockpit-root .tk-card .t i{flex:0 0 auto; width:7px; height:7px; background:var(--c); transform:rotate(45deg); box-shadow:0 0 7px var(--c)}
.cockpit-root .tk-card .t em{font-style:normal; margin-left:auto; color:var(--c); font-size:14px; font-weight:800}
.cockpit-root .tk-card .t em u{text-decoration:none; font-size:9px; font-weight:400; color:#9fd0f5; margin-left:2px}
.cockpit-root .tk-card .l{margin-top:3px; font-size:10.5px; color:#9fd0f5; line-height:1.55; white-space:nowrap}
.cockpit-root .tk-card .l b{color:var(--c); font-weight:700; font-size:11.5px}
.cockpit-root .tk-dia{
  position:absolute; width:15px; height:15px; transform:rotate(45deg);
  background:linear-gradient(135deg,rgba(64,214,255,.75),rgba(64,214,255,.12));
  border:1px solid rgba(120,235,255,.8); box-shadow:0 0 12px rgba(64,214,255,.55);
}
.cockpit-root .tk-dia::after{
  content:''; position:absolute; left:50%; top:50%; width:52px; height:52px;
  transform:translate(-50%,-50%) skewX(0deg) scaleY(.55) rotate(-45deg);
  background:radial-gradient(closest-side,rgba(64,214,255,.34),rgba(64,214,255,0)); pointer-events:none;
}

/* 水深球（核心指标 · 工作室概览） */
.cockpit-root .wv-row{height:100%; display:flex; align-items:flex-end; justify-content:space-around; padding:2px 4px 0}
.cockpit-root .wv-ball{flex:1 1 0; min-width:0; height:100%; display:flex; align-items:flex-end; justify-content:center}
.cockpit-root .wv-ball svg{height:100%; width:auto; max-width:100%; display:block}

/* 光锥椭圆碟环（核心指标 · 资源概览） */
.cockpit-root .res-dishes{
  display:grid; grid-template-columns:repeat(3,1fr); gap:2px 8px; height:calc(100% - 36px);
  align-content:center; justify-items:center; padding:0 4px;
}
.cockpit-root .res-dish{width:100%; max-width:150px; text-align:center}
.cockpit-root .res-dish svg{width:100%; display:block}
.cockpit-root .res-dish .res-lab{font-size:13.5px; font-weight:700; letter-spacing:1px; margin-top:-8px}
.cockpit-root .net-wrap{display:flex; align-items:center; justify-content:center; min-height:0}
.cockpit-root .net-wrap svg{height:100%; max-width:100%}

/* 三指针表盘（题库使用率分学段） */
.cockpit-root .gauge-row{height:calc(100% - 36px); display:flex; align-items:stretch; justify-content:space-around; padding:2px 6px 4px}
.cockpit-root .gauge-item{flex:1 1 0; min-width:0}
.cockpit-root .gauge-item:nth-child(2){flex:1.18 1 0}

/* ============ 屏幕适配 ============
   整页按 1920×1080 设计稿 scale 缩放（见 updateScale），布局尺寸恒定，
   因此不再使用媒体查询断点——媒体查询按真实窗口宽度评估，
   小窗口下触发重排会破坏缩放后的固定布局。 */
</style>
